<template>
  <div
    v-if="!adminProperty"
    class="circular-bar"
  >
    <v-progress-circular
      indeterminate
      color="#04a777"
      size="90"
    ></v-progress-circular>
  </div>
  <div v-else>
    <div class="main" v-if="!isRefresh">
      <div class="main-container">
        <div class="card-section first-section">
          <div class="card-section-header">
            <span>{{ $t("addproperty.add_post") }}</span>
          </div>
          <div class="card-section-body">
            <div class="card-section-body_section">
              <div class="d-flex justify-center mb-11">
                <span class="add-post-title">{{
                  $t("addproperty.select_property_type")
                }}</span>
              </div>
              <div class="d-flex justify-center gap-8 add-property-section">
                <div
                  class="property-type-box"
                  v-for="(item, index) in propertyTypes"
                  :class="[
                    item.type,
                    {
                      'disabled-property':
                        item_type !== item.type &&
                        item_hover !== item.type + 'hover',
                    },
                  ]"
                  :key="`property_${index}`"
                  @mouseover="item_hover = item.type + 'hover'"
                  @mouseleave="item_hover = null"
                  @click="changePropertyType(item.type)"
                >
                  <div class="d-flex justify-center property_name">
                    <img :src="item.image" alt="" />
                  </div>
                  <div
                    class="d-flex justify-center property-type-name"
                    style="text-align: center"
                  >
                    {{ $t(`addproperty.${item.type}`) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-form ref="createForm">
          <div
            class="card-section mt-0"
            v-show="item_type"
            @click="payload.property_type = item_type"
          >
            <v-divider class="divider" />

            <div>
              <div class="card-section-body_section card-section-body-bg">
                <div class="mt-5">
                  <span class="add-post-title">{{
                    $t("addproperty.transaction_type")
                  }}</span>
                </div>
                <div
                  class="d-flex justify-space-between property-deals-section"
                  ref="property_deals_section"
                >
                  <div class="property-deals-section_box" style="width: 100%">
                    <v-switch
                      style="margin-top: 40px; margin-bottom: 10px"
                      color="#04a777"
                      @change="
                        conditional.sale
                          ? () => {
                              return;
                            }
                          : onClickPriceInput('sale', 'checkbox', 'isInSale')
                      "
                      v-model="propertyDeals.isInSale"
                      :label="$t('addproperty.sale')"
                      class="checkmark"
                      :disabled="conditional.sale"
                    ></v-switch>
                    <div
                      class="price-input"
                      @click="
                        conditional.sale
                          ? () => {
                              return;
                            }
                          : onClickPriceInput('sale', '', 'isInSale')
                      "
                    >
                      <v-text-field
                        outlined
                        :rules="[
                          propertyDeals.isInSale && !conditional.sale
                            ? rules.required
                            : true,
                        ]"
                        color="#04a777"
                        class="custom-input"
                        ref="sale"
                        id="sale"
                        :placeholder="$t('addproperty.price')"
                        @blur="spaceValidation($event, 0)"
                        @keyup="spaceValidation($event, 0)"
                        v-model="payload.property_deal_types[0].price"
                        :disabled="!propertyDeals.isInSale || conditional.sale"
                      ></v-text-field>
                      <v-select
                        placeholder="USD"
                        item-color="#04a777"
                        class="custom-currency-select custom-placeholer-color"
                        outlined
                        hide-details
                        :rules="[
                          propertyDeals.isInSale && !conditional.sale
                            ? rules.required
                            : true,
                        ]"
                        :items="currencyTypes"
                        item-text="name"
                        item-value="id"
                        color="#04a777"
                        v-model="
                          payload.property_deal_types[0].currency_type_id
                        "
                        :disabled="!propertyDeals.isInSale || conditional.sale"
                      ></v-select>
                    </div>
                    <div class="conditional-checkbox d-flex justify-end">
                      <v-checkbox
                        class="checkmark"
                        :label="$t('price_conditional')"
                        v-model="conditional.sale"
                        color="#04a777"
                      >
                      </v-checkbox>
                    </div>
                    <v-switch
                      color="#04a777"
                      @change="
                        conditional.rent
                          ? () => {
                              return;
                            }
                          : onClickPriceInput(
                              'monthly',
                              'checkbox',
                              'isInRent',
                              'isInMonthlyRent'
                            )
                      "
                      :disabled="conditional.rent"
                      v-model="propertyDeals.isInRent"
                      :label="$t('addproperty.rent')"
                      class="checkmark rent-section-month"
                    ></v-switch>
                    <div style="line-height: 1 !important" class="d-flex">
                      <div
                        @click="
                          conditional.rent
                            ? () => {
                                return;
                              }
                            : onClickPriceInput(
                                'monthly',
                                '',
                                'isInMonthlyRent',
                                'isInRent',
                                'monthly_rental_fee'
                              )
                        "
                        class="rent-input d-flex mt-3"
                        style="gap: 16px; width: 480px; height: 55px"
                      >
                        <v-text-field
                          class="custom-input first-rent-inp"
                          :rules="[
                            propertyDeals.isInMonthlyRent && !conditional.rent
                              ? rules.required
                              : true,
                          ]"
                          @keydown="numeric($event)"
                          @blur="spaceValidation($event, 1)"
                          @keyup="spaceValidation($event, 1)"
                          :placeholder="$t('addproperty.monthly_fee')"
                          ref="monthly"
                          min="0"
                          outlined
                          color="#04a777"
                          id="mRent"
                          v-model="payload.property_deal_types[1].price"
                          :disabled="
                            !propertyDeals.isInRent ||
                            !propertyDeals.isInMonthlyRent ||
                            conditional.rent
                          "
                        ></v-text-field>
                        <v-select
                          hide-details
                          placeholder="USD"
                          :rules="[
                            propertyDeals.isInMonthlyRent && !conditional.rent
                              ? rules.required
                              : true,
                          ]"
                          class="custom-currency-select custom-placeholer-color"
                          outlined
                          :items="currencyTypes"
                          item-text="name"
                          item-value="id"
                          color="#04a777"
                          item-color="#04a777"
                          v-model="
                            payload.property_deal_types[1].currency_type_id
                          "
                          :disabled="
                            !propertyDeals.isInRent ||
                            !propertyDeals.isInMonthlyRent ||
                            conditional.rent
                          "
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="rent-conditional-checkbox">
                      <v-checkbox
                        class="checkmark"
                        :label="$t('price_conditional')"
                        v-model="conditional.rent"
                        color="#04a777"
                      >
                      </v-checkbox>
                    </div>
                  </div>
                  <div style="width: 100%" class="d-flex justify-end">
                    <div style="padding-right: 0 !important" class="right-side">
                      <v-switch
                        v-if="item_type !== 'land_area'"
                        color="#04a777"
                        @change="
                          conditional.rentDay
                            ? () => {
                                return;
                              }
                            : onClickPriceInput(
                                'daily',
                                'checkbox',
                                'isInRentDay',
                                'isInDailyRent'
                              )
                        "
                        :disabled="conditional.rentDay"
                        v-model="propertyDeals.isInRentDay"
                        :label="$t('addproperty.rentDay')"
                        class="checkmark rent-section-day"
                      ></v-switch>
                      <div v-if="item_type !== 'land_area'" class="d-flex">
                        <div
                          @click="
                            conditional.rentDay
                              ? () => {
                                  return;
                                }
                              : onClickPriceInput(
                                  'daily',
                                  '',
                                  'isInDailyRent',
                                  'isInRentDay',
                                  'daily_rental_fee'
                                )
                          "
                          class="rent-input d-flex mt-3"
                          style="gap: 16px; width: 480px; height: 48px"
                        >
                          <v-text-field
                            class="custom-input"
                            :rules="[
                              propertyDeals.isInDailyRent &&
                              !conditional.rentDay
                                ? rules.required
                                : true,
                            ]"
                            @keydown="numeric($event)"
                            @blur="spaceValidation($event, 2)"
                            @keyup="spaceValidation($event, 2)"
                            :placeholder="$t('addproperty.daily_fee')"
                            ref="daily"
                            color="#04a777"
                            outlined
                            min="0"
                            id="dRent"
                            v-model="payload.property_deal_types[2].price"
                            :disabled="
                              !propertyDeals.isInRentDay ||
                              !propertyDeals.isInDailyRent ||
                              conditional.rentDay
                            "
                          ></v-text-field>
                          <v-select
                            placeholder="USD"
                            hide-details
                            :rules="[
                              propertyDeals.isInDailyRent &&
                              !conditional.rentDay
                                ? rules.required
                                : true,
                            ]"
                            class="custom-currency-select custom-placeholer-color"
                            outlined
                            :items="currencyTypes"
                            item-color="#04a777"
                            item-text="name"
                            item-value="id"
                            color="#04a777"
                            v-model="
                              payload.property_deal_types[2].currency_type_id
                            "
                            :disabled="
                              !propertyDeals.isInRentDay ||
                              !propertyDeals.isInDailyRent ||
                              conditional.rentDay
                            "
                          ></v-select>
                        </div>
                      </div>
                      <div
                        class="rent-conditional-checkbox"
                        v-if="item_type !== 'land_area'"
                      >
                        <v-checkbox
                          class="checkmark"
                          :label="$t('price_conditional')"
                          v-model="conditional.rentDay"
                          color="#04a777"
                        >
                        </v-checkbox>
                      </div>
                      <v-switch
                        class="checkmark receive-quotes"
                        :label="$t('addproperty.receiveQuotes')"
                        color="#ff805a"
                        v-model="payload.is_bids"
                      ></v-switch>
                      <div class="receive-quotes-help">
                        {{ $t("addproperty.receiveQuotesHelp") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-divider
                class="divider"
                v-if="!isSelectingWrongAddress"
              ></v-divider>
              <div
                v-if="!isSelectingWrongAddress"
                class="d-flex justify-space-between select-addres"
                style="padding: 0 35px 15px 40px"
              >
                <div class="d-flex">
                  <img
                    class="img-gps"
                    src="@/assets/images/icons/gps_grey.png"
                  />
                  <p class="map-mention">
                    {{ $t("addproperty.mark_address") }}
                  </p>
                </div>
                <div>
                  <a @click.prevent="isOpenSpamDialog = true">
                    <span id="wrong_address">{{
                      $t("addproperty.incorrect_address")
                    }}</span>
                  </a>
                </div>
              </div>
              <div
                class="card-section-body_section"
                :class="{ 'wrong-address-section': isSelectingWrongAddress }"
              >
                <div
                  class="wrong-address-text-box justify-space-between"
                  v-if="isSelectingWrongAddress"
                >
                  {{ $t("addproperty.wrong_address") }}
                  <v-btn
                    text
                    color="white"
                    class="wrong-address-cancel-button"
                    @click="isSelectingWrongAddress = false"
                  >
                    {{ $t("addproperty.cancel") }}
                    <v-icon class="ml-2">mdi-close-circle-outline</v-icon>
                  </v-btn>
                </div>
                <div
                  :class="{
                    'wrong-address-section-padding': isSelectingWrongAddress,
                  }"
                >
                  <div class="d-flex address-search-fields">
                    <treeselect
                      id="treeSelect"
                      :class="{ 'error-field': isInvalidRegion }"
                      class="combobox-treeselect"
                      @input="onRegionChange"
                      v-model="payload.region"
                      :options="regionsAndStates"
                      :placeholder="
                        !payload.region ? $t('addproperty.region') : ''
                      "
                      :searchable="false"
                      :zIndex="99999999"
                    />
                    <v-combobox
                      @change="onSelectAddress"
                      outlined
                      :rules="[rules.required]"
                      hide-selected
                      color="#04a777"
                      class="combobox custom-placeholer-color ml-3"
                      placeholder="Երևան, Հովսեփյան 8/1"
                      :search-input.sync="payload.address"
                      :items="currentFoundItems"
                      :item-text="(obj) => obj.name"
                      :item-value="(obj) => obj.name"
                      ref="combobox"
                      :disabled="!this.polygonCoords"
                    >
                    </v-combobox>
                  </div>
                  <yandex-map
                    ref="yandMap"
                    @click="(e) => onClickMap(e, 'map')"
                    :controls="controls"
                    :coords="coords"
                    :zoom="zoom.toString()"
                    style="
                      width: 99.8%;
                      max-width: 100%;
                      height: 380px;
                      position: relative;
                    "
                  >
                    <ymap-marker
                      :coords="payload.markerCoords"
                      v-if="payload.markerCoords.length"
                      :marker-stroke="{
                        color: '#04a777',
                        opacity: 0.8,
                        width: 2,
                      }"
                      :marker-fill="{ color: '#05c98e', opacity: 0.4 }"
                      circle-radius="200"
                      :options="{
                        draggable: true,
                      }"
                      @dragend="onDrag"
                      :marker-type="
                        payload.is_address_precise ? 'Circle' : 'Placemark'
                      "
                      :icon="{
                        layout: 'default#image',
                        imageHref: require('@/assets/images/icons/flag-map.svg'),
                      }"
                      markerId="currentPropertyMarkerId"
                    ></ymap-marker>
                    <ymap-marker
                      marker-id="currentPropMId"
                      marker-type="Polygon"
                      @click="onClickMap"
                      :marker-fill="{ color: '#f33', opacity: '0.1' }"
                      :marker-stroke="{
                        color: '#f33',
                        opacity: 0.8,
                        width: 3,
                      }"
                      :coords="polygonCoords"
                      v-if="polygonCoords"
                    ></ymap-marker>
                  </yandex-map>
                  <div
                    style="
                      margin-bottom: 14px;
                      margin-top: 15px;
                      display: flex;
                      align-items: center;
                      gap: 10px;
                      position: relative;
                    "
                  >
                    <v-checkbox
                      color="#04a777"
                      class="checkmark"
                      :label="$t('addproperty.not_exact')"
                      v-model="payload.is_address_precise"
                    ></v-checkbox>
                    <div style="position: relative">
                      <img
                        src="@/assets/images/icons/info.png"
                        alt=""
                        style="margin-right: 16px"
                        @mouseover="warningAddresShow"
                        @mouseleave="warningAddresHide"
                      />
                      <transition name="fade">
                        <div
                          class="warning-box1 warning-box"
                          ref="addresswarning"
                          v-if="isOpenAddressWarning"
                        >
                          {{ $t("addproperty.checkbox_for_exact_address") }}
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <v-divider
              class="divider"
              v-if="!isSelectingWrongAddress"
            ></v-divider>
            <div class="card-section-body_section">
              <div>
                <v-checkbox
                  v-if="
                    item_type === 'mansion' || item_type === 'commercial_area'
                  "
                  class="checkmark"
                  :label="$t('addproperty.has_land')"
                  v-model="isSelectedLandArea"
                  color="#04a777"
                ></v-checkbox>
                <div class="row">
                  <div class="col">
                    <label for="area">
                      <img src="@/images/area.png" alt="image" width="16" />
                      {{ $t("addproperty.area") }}
                    </label>
                    <v-text-field
                      @keydown="numeric($event)"
                      outlined
                      color="#04a777"
                      type="number"
                      min="0"
                      :rules="[rules.required]"
                      id="area"
                      class="custom-input"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) => elem.filter === 'area'
                        ).value
                      "
                    ></v-text-field>
                  </div>

                  <div class="col" v-if="isSelectedLandArea">
                    <label for="land-area" style="white-space: nowrap">
                      <img src="@/images/area.png" alt="image" width="16" />
                      {{ $t("addproperty.landarea") }}
                    </label>
                    <v-text-field
                      @keydown="numeric($event)"
                      outlined
                      color="#04a777"
                      type="number"
                      min="0"
                      :rules="[
                        item_type === 'land_area' ? rules.required : true,
                      ]"
                      id="land-area"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) => elem.filter === 'land_area'
                        ).value
                      "
                      class="custom-input"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col" v-if="item_type !== 'land_area'">
                    <label for="numFloors">
                      <img
                        src="@/images/buildingfloors.png"
                        alt="image"
                        width="16"
                      />
                      {{ $t("addproperty.num_floors_build") }}
                    </label>
                    <v-text-field
                      @keydown="decimals($event)"
                      outlined
                      color="#04a777"
                      type="number"
                      min="0"
                      id="numFloors"
                      class="custom-input"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) =>
                            elem.filter === 'number_of_floors_of_the_building'
                        ).value
                      "
                    ></v-text-field>
                  </div>
                  <div class="col" v-if="item_type !== 'land_area'">
                    <label for="currentFloor">
                      <img src="@/images/stairs.png" alt="image" width="16" />
                      {{ $t("addproperty.property_floor") }}
                    </label>
                    <v-text-field
                      @keydown="decimals($event)"
                      outlined
                      color="#04a777"
                      type="number"
                      min="0"
                      id="currentFloor"
                      class="custom-input"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) => elem.filter === 'apartment_floor'
                        ).value
                      "
                    ></v-text-field>
                  </div>

                  <div
                    class="col pt-3"
                    style="padding: 12px"
                    v-if="item_type !== 'land_area'"
                  >
                    <div>
                      <label class="filter-titles" for="ceiling">
                        <img
                          src="@/assets/images/icons/ceiling-height.svg"
                          class="pr-2"
                          alt=""
                        />{{ $t("mainFilters.ceilingHeight") }}</label
                      >

                      <v-text-field
                        outlined
                        dense
                        type="number"
                        id="ceiling"
                        v-model="
                          payload.property_filter_values.find(
                            (elem) => elem.filter === 'property_height'
                          ).value
                        "
                        item-text="name"
                        class="custom-input"
                        color="#04a777"
                        hide-details
                        @keypress="notAllowComma"
                      >
                      </v-text-field>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="item_type !== 'land_area'">
                  <div class="col">
                    <label for="numRooms">
                      <img src="@/images/bed.png" alt="image" width="16" />
                      {{ $t("addproperty.num_rooms") }}
                    </label>
                    <v-text-field
                      @keydown="decimals($event)"
                      outlined
                      :rules="[
                        item_type !== 'land_area' ? rules.required : true,
                      ]"
                      color="#04a777"
                      type="number"
                      min="0"
                      id="numRooms"
                      class="custom-input"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) => elem.filter === 'number_of_rooms'
                        ).value
                      "
                    ></v-text-field>
                  </div>
                  <div class="col" v-if="item_type !== 'land_area'">
                    <label for="numBath">
                      <img src="@/images/bathroom.png" alt="image" width="16" />
                      {{ $t("addproperty.num_bathroom") }}
                    </label>
                    <v-text-field
                      @keydown="decimals($event)"
                      :rules="[
                        item_type !== 'land_area' ? rules.required : true,
                      ]"
                      outlined
                      color="#04a777"
                      type="number"
                      min="0"
                      id="numBath"
                      class="custom-input"
                      v-model="
                        payload.property_filter_values.find(
                          (elem) => elem.filter === 'number_of_bathrooms'
                        ).value
                      "
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </div>
            <v-divider class="divider mt-8"></v-divider>
            <div>
              <div class="card-section-body_section">
                <v-checkbox
                  class="checkmark"
                  style="margin-bottom: 16px"
                  v-model="payload.new_building"
                  color="#04a777"
                  :label="$t('addproperty.new_building')"
                  v-if="item_type !== 'land_area'"
                ></v-checkbox>
                <div
                  style="margin-bottom: 15px"
                  v-if="item_type !== 'land_area'"
                >
                  <v-select
                    hide-details
                    class="select-big custom-placeholer-color"
                    outlined
                    color="#04a777"
                    item-color="#04a777"
                    v-model="payload.property_state"
                    :placeholder="$t('addproperty.property_cond')"
                    :items="propertyStates"
                    :item-text="(item) => $t(`addproperty.${item.value}`)"
                    item-value="value"
                  ></v-select>
                </div>
                <div
                  style="margin-bottom: 15px"
                  v-if="
                    item_type === 'land_area' ||
                    item_type === 'mansion' ||
                    item_type === 'commercial_area'
                  "
                >
                  <v-select
                    hide-details
                    class="select-big custom-placeholer-color"
                    outlined
                    :class="
                      !isSelectedLandArea && item_type !== 'land_area'
                        ? 'custom-disabled-placeholer-color'
                        : ''
                    "
                    color="#04a777"
                    item-color="#04a777"
                    v-model="payload.land_area_type_id"
                    :placeholder="$t('mainFilters.landType')"
                    :items="landAreaTypes"
                    :item-text="(item) => $t(`addproperty.${item.name}`)"
                    item-value="id"
                    :disabled="!isSelectedLandArea && item_type !== 'land_area'"
                  ></v-select>
                </div>
                <div v-if="item_type !== 'land_area'">
                  <v-select
                    hide-details
                    class="select-big custom-placeholer-color"
                    outlined
                    color="#04a777"
                    item-color="#04a777"
                    v-model="payload.bulding_type_id"
                    :placeholder="$t('addproperty.building_type')"
                    :items="buldingTypes"
                    :item-text="(val) => $t(`building_types.${val.name}`)"
                    item-value="id"
                  >
                    <template v-slot:item="{ item }">
                      {{ $t(`building_types.${item.name}`) }}
                    </template>
                  </v-select>
                </div>
              </div>
              <v-divider class="divider"></v-divider>
            </div>
            <div class="gray-bg">
              <div>
                <v-expansion-panels accordion class="expansion-panel">
                  <v-expansion-panel style="padding-bottom: 18px">
                    <v-expansion-panel-header
                      class="card-section-body_section"
                      expand-icon="mdi-menu-down"
                      style="
                        font-weight: 600;
                        font-size: 18px;
                        padding-top: 15px;
                      "
                      >{{
                        $t("addproperty.communal_fac")
                      }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                      class="card-section-body_section"
                    >
                      <div
                        style="
                          display: grid;
                          grid-template-columns: repeat(5, 1fr);
                          gap: 0 20px;
                        "
                        class="template-columns firstUpperCase"
                      >
                        <div
                          v-for="(val, idx) in payload.filtersList.communal
                            .filters"
                          :key="`filtercheck_${idx}`"
                          v-if="
                            item_type === 'land_area' &&
                            val.filter !== 'heating' &&
                            val.filter !== 'air_conditioner' &&
                            val.filter !== 'internet'
                          "
                        >
                          <v-checkbox
                            class="checkmark"
                            color="#04a777"
                            v-model="val.model"
                            style="height: 20px"
                          >
                            <template slot="label">
                              <img
                                :src="val.images"
                                alt=""
                                width="16"
                                style="margin-right: 8px"
                              />
                              <span class="communal-span">
                                {{ $t(`addproperty.${val.filter}`) }}
                              </span>
                            </template>
                          </v-checkbox>
                        </div>
                        <div
                          v-for="(val, idx) in payload.filtersList.communal
                            .filters"
                          :key="`filtercheck_${idx}`"
                          v-if="item_type !== 'land_area'"
                        >
                          <v-checkbox
                            class="checkmark"
                            color="#04a777"
                            v-model="val.model"
                            style="height: 20px"
                          >
                            <template slot="label">
                              <img
                                :src="val.images"
                                alt=""
                                width="16"
                                style="margin-right: 8px"
                              />
                              <span class="communal-span">
                                {{ $t(`addproperty.${val.filter}`) }}
                              </span>
                            </template>
                          </v-checkbox>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel
                    style="padding-bottom: 18px"
                    v-if="
                      !isLoadingFilters &&
                      (propertyDeals.isInSale || conditional.sale)
                    "
                  >
                    <v-expansion-panel-header
                      class="card-section-body_section"
                      expand-icon="mdi-menu-down"
                      style="
                        font-weight: 600;
                        font-size: 18px;
                        padding-top: 15px;
                      "
                      >{{
                        $t("other_filters.other_sell")
                      }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                      class="card-section-body_section"
                    >
                      <div
                        v-for="(itm, idx, ind) in payload.filtersList
                          .other_sell"
                        :key="`subfilterrent_${idx}`"
                      >
                        <div v-if="ind != getLengthOfFiltersSell - 1">
                          <span class="bold subtitle">{{
                            $t(`other_filters.${idx}`)
                          }}</span>
                          <div
                            style="
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 0 20px;
                            "
                            class="template-columns"
                          >
                            <div
                              v-for="(filter, index) in itm.filters"
                              :key="`rentfilter_${index}`"
                              class="firstUpperCase"
                            >
                              <v-checkbox
                                color="#04a777"
                                class="checkmark mb-3"
                                v-model="filter.model"
                                style="height: 20px"
                              >
                                <template slot="label">
                                  <span
                                    style="font-size: 14px; white-space: normal"
                                    >{{ filter.title }}</span
                                  >
                                </template>
                              </v-checkbox>
                            </div>
                          </div>
                          <v-divider
                            style="border-color: black; margin-top: 30px"
                          ></v-divider>
                        </div>
                        <div v-else>
                          <span class="bold subtitle">{{
                            $t(`other_filters.${idx}`)
                          }}</span>
                          <div
                            style="
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 0 20px;
                            "
                            class="template-columns"
                          >
                            <div
                              v-for="(filter, index) in itm.filters"
                              :key="`rentfilter_${index}`"
                              class="firstUpperCase"
                            >
                              <v-checkbox
                                color="#04a777"
                                class="checkmark mb-3"
                                v-model="filter.model"
                                style="height: 20px"
                              >
                                <template slot="label">
                                  <span
                                    style="font-size: 14px; white-space: normal"
                                    >{{ filter.title }}</span
                                  >
                                </template>
                              </v-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel
                    style="padding-bottom: 18px; padding-top: 15px"
                    v-if="
                      !isLoadingFilters &&
                      (propertyDeals.isInRent ||
                        propertyDeals.isInRentDay ||
                        conditional.rent ||
                        conditional.rentDay)
                    "
                  >
                    <v-expansion-panel-header
                      class="card-section-body_section"
                      expand-icon="mdi-menu-down"
                      style="font-weight: 600; font-size: 18px"
                      >{{
                        $t("other_filters.other_rent")
                      }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                      class="card-section-body_section"
                    >
                      <div
                        v-for="(itm, idx, ind) in payload.filtersList
                          .other_rent"
                        :key="`subfiltersell_${idx}`"
                      >
                        <div v-if="ind != getLengthOfFiltersRent - 1">
                          <span class="bold subtitle">{{
                            $t(`other_filters.${idx}`)
                          }}</span>
                          <div
                            style="
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 0 20px;
                            "
                            class="template-columns"
                          >
                            <div
                              v-for="(filter, index) in itm.filters"
                              :key="`rentfilter_${index}`"
                              class="firstUpperCase"
                            >
                              <v-checkbox
                                color="#04a777"
                                class="checkmark"
                                v-model="filter.model"
                                style="height: 20px"
                              >
                                <template slot="label">
                                  <span
                                    style="
                                      font-size: 14px;
                                      white-space: normal;
                                      position: absolute;
                                    "
                                    >{{ filter.title }}</span
                                  >
                                </template>
                              </v-checkbox>
                            </div>
                          </div>
                          <v-divider
                            style="border-color: black; margin-top: 30px"
                          ></v-divider>
                        </div>
                        <div v-else>
                          <span class="bold subtitle">{{
                            $t(`other_filters.${idx}`)
                          }}</span>
                          <div
                            style="
                              display: grid;
                              grid-template-columns: repeat(4, 1fr);
                              gap: 0 20px;
                            "
                            class="template-columns"
                          >
                            <div
                              v-for="(filter, index) in itm.filters"
                              :key="`rentfilter_${index}`"
                              class="firstUpperCase"
                            >
                              <v-checkbox
                                color="#04a777"
                                class="checkmark"
                                v-model="filter.model"
                                style="height: 20px"
                              >
                                <template slot="label">
                                  <span style="font-size: 14px">{{
                                    filter.title
                                  }}</span>
                                </template>
                              </v-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
            <v-divider class="divider"></v-divider>
            <div class="card-section-body_section">
              <div
                class="translation_button"
                style="
                  border: 1px solid #e0e0e0;
                  border-radius: 10px 10px 0 0;
                  overflow: hidden;
                "
              >
                <div
                  class="d-flex justify-space-between align-items-center translate-switch-button"
                  style="border-bottom: 1px solid #e0e0e0"
                >
                  <v-tabs color="#04a777" v-model="tab" class="custom-tabs">
                    <v-tab class="tab-title"
                      ><img
                        src="@/assets/images/icons/eng.png"
                        alt=""
                        height="24"
                      /><span class="description-lang">English</span></v-tab
                    >
                    <v-tab class="tab-title"
                      ><img
                        src="@/assets/images/icons/arm.png"
                        alt=""
                        height="24"
                      />
                      <span class="description-lang">Հայերեն</span></v-tab
                    >
                    <v-tab class="tab-title"
                      ><img
                        src="@/assets/images/icons/rus.png"
                        alt=""
                        height="24"
                      />
                      <span class="description-lang">русский</span></v-tab
                    >
                   
                  </v-tabs>
                  <img
                    src="@/assets/images/translate.svg"
                    alt=""
                    height="25"
                    class="translation_icon"
                  />
                  <v-switch
                    color="#04a777"
                    @change="onSwitchAutoTranslate('en', 'ru', 'hy')"
                    style="white-space: nowrap"
                    hide-details
                    class="translate-switch"
                    v-model="autoTranslate"
                    :label="$t('addproperty.autoTranslate')"
                  ></v-switch>
                </div>

                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-textarea
                      @input="debounceSearch2('en', 'ru', 'en')"
                      class="tab-textarea custom-placeholer-color pb-100"
                      color="#04a777"
                      v-model="
                        payload.translate_descriptions.find(
                          (elem) => elem.language === 'en'
                        ).description
                      "
                      rows="10"
                      placeholder="Ավելացրեք նկարագրություն Ձեր հայտարարությանը"
                    >
                    </v-textarea>
                    <v-btn
                      @click="openSampleDialog(0)"
                      color="rgba(4, 167, 119, 0.05)"
                      absolute
                      style="
                        bottom: 55px;
                        left: 35px;
                        color: #777777;
                        background-color: rgba(4, 167, 119, 0.05);
                      "
                      class="inputAreaBtn"
                    >
                      Օգտագործել նմուշ
                    </v-btn>
                  </v-tab-item>
                  <v-tab-item>
                    <div style="position: relative">
                      <v-textarea
                        @input="debounceSearch2('ru', 'en', 'hy')"
                        class="tab-textarea custom-placeholer-color"
                        color="#04a777"
                        v-model="
                          payload.translate_descriptions.find(
                            (elem) => elem.language === 'ru'
                          ).description
                        "
                        rows="10"
                        placeholder="Добавьте описание к своему объявлению"
                      >
                      </v-textarea>
                      <v-btn
                        @click="openSampleDialog(1)"
                        color="rgba(4, 167, 119, 0.05)"
                        style="
                          position: absolute;
                          bottom: 55px;
                          left: 35px;
                          color: #777777;
                          background-color: rgba(4, 167, 119, 0.05);
                        "
                        class="inputAreaBtn"
                      >
                        Использовать образец
                      </v-btn>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <div style="position: relative">
                      <v-textarea
                        @input="debounceSearch2('hy', 'ru', 'en')"
                        class="tab-textarea custom-placeholer-color"
                        color="#04a777"
                        v-model="
                          payload.translate_descriptions.find(
                            (elem) => elem.language === 'hy'
                          ).description
                        "
                        rows="10"
                        placeholder="Add a description to your  announcement"
                      >
                      </v-textarea>
                      <v-btn
                        @click="openSampleDialog(2)"
                        color="rgba(4, 167, 119, 0.05)"
                        style="
                          position: absolute;
                          bottom: 55px;
                          left: 35px;
                          color: #777777;
                          background-color: rgba(4, 167, 119, 0.05);
                        "
                        class="inputAreaBtn"
                      >
                        Use sample
                      </v-btn>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
            <v-divider class="divider"></v-divider>
            <div class="card-section-body_section">
              <div style="display: flex; align-items: flex-start; gap: 20px">
                <div>
                  <label style="cursor: pointer" class="upload-file">
                    <img
                      :src="
                        require(`@/images/${$t('addproperty.add_picture')}`)
                      "
                      width="198"
                    />
                    <input
                      type="file"
                      class="file"
                      @change="onAddPicture"
                      style="display: none"
                      id="file"
                      ref="files"
                      name="file[]"
                      multiple
                      accept="image/*"
                    />
                  </label>
                  <v-checkbox
                    v-if="
                      adminProperty.user && adminProperty.user.user_type.name === 'agency'
                    "
                    color="#04a777"
                    v-model="isUsedLogo"
                    :label="$t('use_logo')"
                    class="checkmark label-underline Logo_checkmark"
                  >
                  </v-checkbox>
                </div>
                <div class="image-box-edit" v-if="editPropertyImages.length">
                  <div
                    class="position-relative"
                    style="width: max-content"
                    v-for="(item, index) in editPropertyImages"
                    :key="`edit-image_${index}`"
                  >
                    <v-btn
                      width="20"
                      min-width="20"
                      height="20"
                      min-height="20"
                      absolute
                      top
                      right
                      @click="deleteEditImage(item.id)"
                    >
                      <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                    <img
                      :src="item.name.original"
                      alt="image"
                      style="object-fit: cover"
                      width="210"
                      height="145"
                    />
                  </div>
                </div>
                <draggable
                  v-model="payload.filesArr"
                  class="image-box"
                  style="display: flex; gap: 8px"
                  group="images"
                  @start="drag = true"
                  @end="drag = false"
                >
                  <div
                    class="position-relative"
                    v-for="(item, index) in payload.filesArr.slice(0, 5)"
                    :key="`prevImage_${index}`"
                  >
                    <v-btn
                      width="20"
                      min-width="20"
                      height="20"
                      min-height="20"
                      absolute
                      top
                      v-if="
                        index !== payload.filesArr.slice(0, 5).length - 1 ||
                        payload.filesArr.slice(0, 5).length ===
                          payload.filesArr.length
                      "
                      right
                      @click="deleteImage(index)"
                    >
                      <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                    <div
                      class="more-button w-100 position-absolute"
                      @click="isOpenViewAll = true"
                      style="height: 145px"
                      v-if="
                        index === payload.filesArr.slice(0, 5).length - 1 &&
                        payload.filesArr.length !==
                          payload.filesArr.slice(0, 5).length
                      "
                    >
                      +
                      {{
                        payload.filesArr.length -
                        payload.filesArr.slice(0, 5).length
                      }}
                    </div>
                    <img
                      :src="fileToObjectUrl(item)"
                      alt="image"
                      style="object-fit: cover"
                      width="210"
                      height="145"
                    />
                  </div>
                </draggable>
              </div>
            </div>
            <v-divider class="divider"></v-divider>
            <div class="card-section-body_section" v-if="adminProperty.user">
              <p class="bold contact-title">
                {{ $t("addproperty.contact_info") }}
              </p>
              <div
                style="padding-top: 20px"
                class="d-flex justify-space-between phone-info-section align-items-center"
              >
                <div class="contacts-info">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <img
                      :src="
                        adminProperty.user.picture.min
                          ? adminProperty.user.picture.min
                          : require('@/assets/images/icons/menu user.svg')
                      "
                      alt=""
                      style="border-radius: 50%"
                      width="45"
                      @error="
                        (e) =>
                          (e.target.src = require('@/assets/images/icons/menu user.svg'))
                      "
                    />
                    <div>
                      <span>{{ adminProperty.user.full_name }}</span>
                      <div>
                        <span style="opacity: 0.36; font-size: 13px">
                          {{ adminProperty.user.email }}
                        </span>
                      </div>
                      <div>
                        <span style="opacity: 0.36; font-size: 13px">
                          {{
                            adminProperty.user.is_admin
                              ? $t("admin")
                              : $t("mainFilters." + adminProperty.user.user_type.name)
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                  "
                  class="numbers_box"
                >
                  <div
                    class="phone-col list-phones d-flex align-items-center"
                    style="flex-wrap: wrap; justify-content: center"
                  >
                    <div
                      v-for="(item, index) in adminProperty.user.phones.filter((el) =>
                        payload.phone.attach_phones.includes(+el.id)
                      )"
                      :key="`phoneList_${index}`"
                      style="margin-bottom: 10px"
                      class="phone-number-box"
                    >
                      <div class="d-flex align-items-center">
                        <span class="phone-number"
                          >( +{{ item.code }} ) {{ item.number }}</span
                        >
                        <v-btn
                          icon
                          color="#c4c4c4"
                          @click="deleteAttachPhone(+item.id)"
                        >
                          <v-icon size="16">mdi-close-circle</v-icon>
                        </v-btn>
                      </div>
                      <div
                        style="display: flex; justify-content: center"
                        class="phone-info-variables"
                      >
                        <img
                          style="margin-right: 8px; margin-top: 5px"
                          src="../../assets/images/icons/Viber.svg"
                          width="20"
                          alt=""
                          v-if="item.whatsapp"
                        />
                        <img
                          style="margin-right: 8px; margin-top: 5px"
                          src="../../assets/images/icons/Whatsapp.svg"
                          alt=""
                          width="20"
                          v-if="item.viber"
                        />
                        <img
                          src="../../assets/images/icons/Telegram.svg"
                          alt=""
                          style="margin-top: 5px"
                          width="20"
                          v-if="item.telegram"
                        />
                      </div>
                    </div>
                    <div
                      v-if="isConfirmed"
                      class="d-flex align-items-center new-phone"
                      style="flex-wrap: wrap; justify-content: center"
                    >
                      <div>
                        <span class="phone-number"
                          >{{ payload.phone.new_phones.code }}
                          {{ payload.phone.new_phones.number }}</span
                        >
                        <div
                          style="display: flex; justify-content: center"
                          class="phone-info-variables"
                        >
                          <img
                            style="margin-right: 8px; margin-top: 5px"
                            src="../../assets/images/icons/Viber.svg"
                            width="20"
                            alt=""
                            v-if="payload.phone.new_phones.viber"
                          />
                          <img
                            style="margin-right: 8px; margin-top: 5px"
                            src="../../assets/images/icons/Whatsapp.svg"
                            alt=""
                            width="20"
                            v-if="payload.phone.new_phones.whatsapp"
                          />
                          <img
                            style="margin-top: 5px"
                            src="../../assets/images/icons/Telegram.svg"
                            alt=""
                            width="20"
                            v-if="payload.phone.new_phones.telegram"
                          />
                        </div>
                      </div>
                      <div class="attached-phone d-flex align-items-center">
                        <div>
                          <v-btn icon color="#c4c4c4" @click="onCloseAddNumber">
                            <v-icon size="16">mdi-close-circle</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="isConfirmed"
                    style="position: relative; margin-left: 16px"
                  >
                    <img
                      src="@/assets/images/icons/info.png"
                      alt=""
                      @mouseover="warningPhoneShow"
                      @mouseleave="warningPhoneHide"
                    />
                    <transition name="fade">
                      <div
                        class="warning-box warning-box2"
                        ref="emailwarning"
                        v-if="isOpenPhoneWarning"
                        style="gap: 16px"
                      >
                        {{ $t("addproperty.Phone_information") }}
                      </div>
                    </transition>
                  </div>
                  <v-btn
                    outlined
                    class="add-new-phone-button"
                    @click="isOpenAddNewNumberDialog = true"
                    v-if="!isConfirmed"
                  >
                    {{ $t("addproperty.add_phone_number") }}
                    <v-icon class="ml-2" color="#04a777"
                      >mdi-plus-circle</v-icon
                    >
                  </v-btn>
                </div>
              </div>
            </div>
            <v-divider class="divider"></v-divider>
            <div class="card-section-body_section" v-if="isAgencyType">
              <div
                class="d-flex w-60 align-center justify-space-between mb-2 additional-email-box"
              >
                <span>{{ $t("addproperty.user_email") }}</span>
                <v-text-field
                  type="email"
                  ref="email"
                  outlined
                  :rules="[rules.email]"
                  class="custom-input ml-2 pt-8 custom-placeholer-color"
                  color="#04a777"
                  placeholder="example@gmail.com"
                  v-model="payload.additional_email"
                />
                <div style="position: relative; margin-left: 16px">
                  <img
                    src="@/assets/images/icons/info.png"
                    alt=""
                    @mouseover="warningEmailShow"
                    @mouseleave="warningEmailHide"
                  />
                  <transition name="fade">
                    <div
                      class="warning-box warning-box2"
                      ref="emailwarning"
                      v-if="isOpenEmailWarning"
                      style="gap: 16px"
                    >
                      {{ $t("addproperty.email_information") }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <v-divider class="divider" v-if="isAgencyType"></v-divider>
            <div
              class="card-section-footer d-flex justify-space-between bottom-buttons"
              style="flex-wrap: wrap; gap: 30px; padding-left: 5px"
            >
              <div
                class="d-flex justify-space-between footer-buttons align-center"
                style="gap: 16px; margin-right: 30px"
              >
                <v-btn
                  text
                  color="red"
                  class="action"
                  @click="$router.push('/admin/properties')"
                  >{{ $t("addproperty.cancel") }}
                </v-btn>
              </div>
              <v-btn
                class="action preview-button"
                style="color: white"
                color="#04a777"
                height="48"
                :loading="saveButtonLoading"
                @click="onPreview"
                >Save</v-btn
              >
            </div>
          </div>
        </v-form>
      </div>
    </div>
    <v-snackbar color="red" height="40" v-model="isInvalid">
      <div>
        <span>{{ $t("addproperty.snackbar_validation_message") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="isInvalid = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="showOutsideSnackbar">
      <div>
        <span>{{ $t("address_allocation_message") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="showOutsideSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="isInvalidRegion">
      <div>
        <span>{{ $t("addproperty.select_region") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="isInvalidRegion = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="inValidPrice">
      <div>
        <span>{{ $t("addproperty.select_deal_type") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="inValidPrice = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="showImageSizeSnackbar">
      <div>
        <span>{{ $t("image_size_warning") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="showImageSizeSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="red" height="40" v-model="showImageCountSnackbar">
      <div>
        <span>{{ $t("image_count_warning") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="showImageCountSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      color="orange"
      height="40"
      v-model="showTranslateWarning"
      centered
    >
      <div>
        <span>{{ $t("addproperty.nothing_to_translate") }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="showTranslateWarning = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="isOpenSampleDialog" width="1000" height="1300">
      <v-card style="background-color: white">
        <v-card-title class="font-weight-bold d-flex pt-6 justify-center">
          <p style="width: 90%; text-align: center; word-wrap: normal">
            {{ $t("addproperty.use_sample") }} :
            {{ $t(`addproperty.${item_type}`) }}
          </p>
          <v-btn absolute right top icon @click="isOpenSampleDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card class="d-grid justify-center pt-3 sampleDialog">
          <v-card
            v-for="(item, index) in samples[item_type]"
            :key="index"
            class="flex"
          >
            <v-card class="mb-16" elevation="0">
              <v-btn
                absolute
                outlined
                color="#e6e6e6"
                top
                right
                icon
                @click="item.langIndex += 1"
                style="border-radius: 5px"
              >
                <v-icon color="black" size="20">mdi-translate</v-icon>
              </v-btn>
              <v-card-text
                class="pt-10 mb-26 scroll"
                style="height: 339px; overflow-y: scroll"
              >
                <p class="bold">
                  <img src="@/assets/images/textSample.png" width="18px" />
                  {{ $t("addproperty.sample") }} {{ index + 1 }}
                </p>
                <p>
                  {{ $t(item.text + (item.langIndex % 3)) }}
                </p>
              </v-card-text>
            </v-card>
            <v-btn
              absolute
              right
              bottom
              color="#04a777"
              class="spam-button-outlined mb-2 mr-2"
              style="text-transform: none"
              dark
              @click="
                typeSample(
                  $t(item.text + 0),
                  $t(item.text + 1),
                  $t(item.text + 2)
                )
              "
            >
              <v-icon size="16">{{ $t("mainFilters.select") }}</v-icon>
            </v-btn>
          </v-card>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isOpenSpamDialog" width="320">
      <v-card>
        <v-card-title class="d-flex justify-center">
          <img src="@/assets/images/icons/problem.svg" alt="" />
        </v-card-title>
        <v-card-text class="d-flex justify-center">
          <span class="font-weight-bold spam-text text-center">
            {{ $t("addproperty.wrong_address") }}
          </span>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            outlined
            color="#04a777"
            class="spam-button-outlined"
            @click="isOpenSpamDialog = false"
            >{{ $t("addproperty.cancel") }}</v-btn
          >
          <v-btn
            color="#04a777"
            class="spam-button"
            @click="
              isSelectingWrongAddress = true;
              isOpenSpamDialog = false;
            "
            >{{ $t("mainFilters.confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isOpenViewAll"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="#04a777"
          dark
          class="d-flex justify-center"
          height="100"
        >
          <h1>Images</h1>
        </v-toolbar>
        <v-btn
          absolute
          color="white"
          top
          right
          icon
          @click="isOpenViewAll = false"
        >
          <v-icon size="32">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="pt-10">
          <Gallery :images="galleryImages" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      content-class="add-phone-dialog"
      transition="dialog-bottom-transition"
      max-width="370"
      v-model="isOpenAddNewNumberDialog"
    >
      <template>
        <v-card style="padding-bottom: 15px">
          <v-toolbar
            color="white"
            style="color: black"
            elevation="1"
            outlined
            class="font-weight-bolder d-flex justify-center"
            >{{ $t("add_phone") }}</v-toolbar
          >
          <v-card-text class="add_phone" style="padding-top: 20px">
            <VuePhoneNumberInput
              style="gap: 20px; border-radius: 5px"
              @update="onNewNumberUpdate"
              default-country-code="AM"
              valid-color="#04a777"
              class="phone-input"
              id="phone-input"
              color="#04a777"
              v-model="payload.phone.add_phones.number"
            >
              <template slot="arrow">
                <img src="@/assets/images/icons/arrow-down.svg" alt="" />
              </template>
            </VuePhoneNumberInput>
            <div class="d-flex justify-space-between" style="gap: 0px">
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="payload.phone.add_phones.viber"
                  :label="`Viber`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="payload.phone.add_phones.whatsapp"
                  :label="`Whatsapp`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
              <div class="d-flex">
                <v-checkbox
                  color="#04a777"
                  v-model="payload.phone.add_phones.telegram"
                  :label="`Telegram`"
                  class="checkmark"
                >
                </v-checkbox>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-space-between">
            <v-btn
              style="width: 150px; margin-left: 8px"
              outlined
              class="cancel-add-new-number-button"
              @click="onCloseAddNumber"
              >{{ $t("addproperty.cancel") }}</v-btn
            >
            <v-btn
              class="add-new-number-button"
              style="width: 150px; margin-right: 8px"
              color="#04a777"
              :disabled="!isValidNewPhone"
              @click="onCloseAddNumber('confirm')"
              >{{ $t("save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import draggable from "vuedraggable";
import Gallery from "@/pages/addProperty/Gallery";
import VuePhoneNumberInput from "vue-phone-number-input";
import Treeselect from "@riophae/vue-treeselect";
import regions from "@/data/Armenia.json";
import localPolygons from "@/data/mapLocalRegions.json";
import { loadYmap } from "vue-yandex-maps";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "AdminEditProperty",
  components: {
    draggable,
    Gallery,
    VuePhoneNumberInput,
    Treeselect,
  },
  data() {
    return {
      regions,
      localPolygons,
      showOutsideSnackbar: false,
      ymaps: null,
      isInvalidRegion: false,
      item_hover: null,
      conditional: {
        sale: false,
        rent: false,
        rentDay: false,
      },
      langIndex: 0,
      landAreaTypes: [],
      editPropertyImages: [],
      isUsedLogo: true,
      receiveQuotes: null,
      samples: {
        apartment: [
          {
            text: "addproperty.samples[0].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[1].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[2].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[3].text",
            langIndex: 0,
          },
        ],
        mansion: [
          {
            text: "addproperty.samples[4].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[5].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[6].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[7].text",
            langIndex: 0,
          },
        ],
        land_area: [
          {
            text: "addproperty.samples[8].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[9].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[10].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[11].text",
            langIndex: 0,
          },
        ],
        commercial_area: [
          {
            text: "addproperty.samples[12].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[13].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[14].text",
            langIndex: 0,
          },
          {
            text: "addproperty.samples[15].text",
            langIndex: 0,
          },
        ],
      },
      item_type: null,
      coords: [40.148143, 44.513767],
      drag: false,
      controls: [],
      isOpenSampleDialog: false,
      isOpenSpamDialog: false,
      isOpenImgDialog: false,
      isConfirmed: false,
      isOpenAddNewNumberDialog: false,
      currentFoundItems: [],
      isOpenViewAll: false,
      zoom: 12.4,

      payload: {
        region: null,
        property_type: null,
        land_area_type_id: null,
        property_images_delete_ids: [],
        property_deal_types: [
          { deal_type: "sale", price: "", currency_type_id: "1" },
          {
            deal_type: "monthly_rental_fee",
            price: "",
            currency_type_id: "1",
          },
          { deal_type: "daily_rental_fee", price: "", currency_type_id: "1" },
        ],
        phone: {
          add_phones: {
            code: "",
            number: null,
            viber: false,
            whatsapp: false,
            telegram: false,
          },
          attach_phones: [],
          new_phones: {},
        },
        markerCoords: [],
        property_filter_values: [
          { filter: "area", value: null },
          { filter: "number_of_floors_of_the_building", value: null },
          { filter: "apartment_floor", value: null },
          { filter: "number_of_rooms", value: null },
          { filter: "number_of_bathrooms", value: null },
          { filter: "land_area", value: null },
          { filter: "property_height", value: null },
        ],
        new_building: false,
        property_state: null,
        bulding_type_id: null,
        translate_descriptions: [
         { language: "en", description: null },
          { language: "ru", description: null },
            { language: "hy", description: null },
          
        ],
        address: "",
        is_address_precise: false,
        filesArr: [],
        is_bids: false,
        additional_email: null,
        filtersList: {
          communal: {
            name: "communal_fac",
            filters: [
              {
                filter: "heating",
                title: this.$t("addproperty.heat"),
                images: require("../../images/utilities/1.png"),
                model: false,
              },
              {
                filter: "gas",
                title: this.$t("addproperty.gas"),
                images: require("../../images/utilities/2.png"),
                model: false,
              },
              {
                filter: "hot_water",
                title: this.$t("addproperty.hot_water"),
                images: require("../../images/utilities/3.png"),
                model: false,
              },
              {
                filter: "electrycity",
                title: this.$t("addproperty.electry"),
                images: require("../../images/utilities/4.png"),
                model: false,
              },
              {
                filter: "permanent_water",
                title: this.$t("addproperty.perm_water"),
                images: require("../../images/utilities/5.png"),
                model: false,
              },
              {
                filter: "internet",
                title: this.$t("addproperty.internet"),
                images: require("../../images/utilities/6.png"),
                model: false,
              },
              {
                filter: "air_conditioner",
                title: this.$t("addproperty.air_cond"),
                images: require("../../images/utilities/7.png"),
                model: false,
              },
              {
                filter: "irrigation",
                title: this.$t("addproperty.irrigation"),
                images: require("../../images/utilities/8.png"),
                model: false,
              },
              {
                filter: "drainage",
                title: this.$t("addproperty.drainage"),
                images: require("../../images/utilities/9.png"),
                model: false,
              },
            ],
          },
          other_sell: {},
          other_rent: {},
        },
      },
      saveButtonLoading: false,
      propertyDeals: {
        isInSale: false,
        isInRent: false,
        isInRentDay: false,
        isInMonthlyRent: false,
        isInDailyRent: false,
      },
      isLoadingFilters: false,
      isInvalid: false,
      inValidPrice: false,
      showTranslateWarning: false,
      isSelectedLandArea: false,
      apolloToken: localStorage.getItem("apollo-token"),
      formData: new FormData(),
      tab: "English",

      debounce: null,
      debounce2: null,
      getPropertyTypeFilters: [],
      isSelectingWrongAddress: false,
      autoTranslate: true,
      isOpenAddressWarning: false,
      isOpenEmailWarning: false,
      isOpenPhoneWarning: false,
      showImageSizeSnackbar: false,
      showImageCountSnackbar: false,
      editDataFilters: [],
      isRefresh: false,
      isValidNewPhone: false,
      polygonCoords: null,
    };
  },
  computed: {
    regionsAndStates() {
      const arr = [];
      this.regions.forEach((item) => {
        if (item.states.length) {
          arr.push({
            id: item.region,
            label: this.$t(`regions.${item.region}`),
            children: item.states.map((el) => {
              return {
                id: el,
                label: this.$t(`states.${el}`),
              };
            }),
          });
        } else {
          arr.push({
            id: item.region,
            label: this.$t(`regions.${item.region}`),
          });
        }
      });
      return arr;
    },
    rules() {
      return {
        required: (value) => !!value || this.requiredMessage,
        email: (v) => !v || /.+@.+\..+/.test(v) || this.emailMessage,
      };
    },
    requiredMessage() {
      return this.$t("addproperty.required");
    },
    emailMessage() {
      this.$t("addproperty.eMail_invalid");
    },
    getLengthOfFiltersRent() {
      return Object.keys(this.payload.filtersList.other_rent).length;
    },
    getLengthOfFiltersSell() {
      return Object.keys(this.payload.filtersList.other_sell).length;
    },
    isAgencyType() {
      return localStorage.getItem("user-type") === "agency";
    },
    propertyStates() {
      return [
        { value: "overhauled" },
        { value: "euro_renovated" },
        { value: "renovated" },
        { value: "good" },
        { value: "average" },
        { value: "sufficient" },
        { value: "zero_condition" },
      ];
    },
    propertyTypes() {
      return [
        {
          type: "apartment",
          color: "#25bcf8",
          image: require("@/assets/images/icons/add-commercialNoneShodow.svg"),
        },
        {
          type: "mansion",
          color: "#04a777",
          image: require("@/assets/images/icons/add-mansionNoneShodow.svg"),
        },
        {
          type: "land_area",
          color: "#ff6823",
          image: require("@/assets/images/icons/add-landNoneShodow.svg"),
        },
        {
          type: "commercial_area",
          color: "#e63abe",
          image: require("@/assets/images/icons/add-apartmentNoneShodow.svg"),
        },
      ];
    },
    groupedPropertyTypeFiltersSell() {
      if (this.getPropertyTypeFilters.length) {
        let data = [...this.getSortedFilters("sell")].reduce((reducer, e) => {
          let name = e.filter_group.name;
          if (!reducer[name])
            reducer[name] = {
              name,
              filters: [
                {
                  filter: e.name,
                  model: false,
                  title: this.$t(`other_filters.${e.name}`),
                },
              ],
            };
          else {
            reducer[name].filters.push({
              filter: e.name,
              model: false,
              title: this.$t(`other_filters.${e.name}`),
            });
          }
          return reducer;
        }, {});
        delete data.undefined;
        return data;
      } else {
        return [];
      }
    },
    groupedPropertyTypeFiltersRent() {
      if (this.getPropertyTypeFilters.length) {
        let data = [...this.getSortedFilters("rent")].reduce((reducer, e) => {
          let name = e.filter_group.name;
          if (!reducer[name])
            reducer[name] = {
              name,
              filters: [
                {
                  filter: e.name,
                  model: false,
                  title: this.$t(`other_filters.${e.name}`),
                },
              ],
            };
          else {
            reducer[name].filters.push({
              filter: e.name,
              model: false,
              title: this.$t(`other_filters.${e.name}`),
            });
          }
          return reducer;
        }, {});
        delete data.undefined;
        return data;
      } else {
        return [];
      }
    },
    galleryImages() {
      const images = [];
      this.payload.filesArr.forEach((file) => {
        images.push((window.URL || window.webkitURL).createObjectURL(file));
      });
      return images;
    },
    isSelectedOneOfPrices() {
      return (
        this.propertyDeals.isInSale ||
        this.propertyDeals.isInRent ||
        this.propertyDeals.isInRentDay ||
        this.conditional.sale ||
        this.conditional.rent ||
        this.conditional.rentDay
      );
    },
  },
  watch: {
    "adminProperty.user"(v) {
      if (v) {
        this.payload.phone.attach_phones = v.phones.slice(0, 3).map((el) => {
          return +el.id;
        });
      }
    },
    markerCoords: {
      deep: true,
      handler(v) {
        if (v.length) {
          this.onGetAddress();
        }
      },
    },
    "conditional.sale"(v) {
      if (v) {
        this.propertyDeals.isInSale = false;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "sale"
        ).price = null;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "sale"
        ).currency_type_id = null;
      }
    },
    "conditional.rent"(v) {
      if (v) {
        this.propertyDeals.isInRent = false;
        this.propertyDeals.isInMonthlyRent = false;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "monthly_rental_fee"
        ).price = null;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "monthly_rental_fee"
        ).currency_type_id = null;
      } else {
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "monthly_rental_fee"
        ).price = "";
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "monthly_rental_fee"
        ).currency_type_id = "1";
      }
    },
    "conditional.rentDay"(v) {
      if (v) {
        this.propertyDeals.isInRentDay = false;
        this.propertyDeals.isInDailyRent = false;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "daily_rental_fee"
        ).price = null;
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "daily_rental_fee"
        ).currency_type_id = null;
      } else {
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "daily_rental_fee"
        ).price = "";
        this.payload.property_deal_types.find(
          (el) => el.deal_type === "daily_rental_fee"
        ).currency_type_id = "1";
      }
    },
    "payload.property_type": {
      handler() {
        this.refetchFilters();
      },
    },
    currentFoundItems(v) {
      if (v.length === 1 && this.payload.address === v[0].name) {
        this.payload.markerCoords = v[0].pos.reverse();
      }
    },
    groupedPropertyTypeFiltersSell() {
      this.payload.filtersList.other_sell = this.groupedPropertyTypeFiltersSell;
      this.payload.filtersList.other_rent = this.groupedPropertyTypeFiltersRent;
      if (this.editDataFilters.length) {
        const sellFilters = this.editDataFilters.filter(
          (el) => el.filter.deal_type === "sell"
        );
        for (let i in this.payload.filtersList.other_sell) {
          for (let j in this.payload.filtersList.other_sell[i].filters) {
            if (
              sellFilters.find(
                (el) =>
                  el.filter.name ===
                  this.payload.filtersList.other_sell[i].filters[j].filter
              )
            ) {
              this.payload.filtersList.other_sell[i].filters[j].model = true;
            }
          }
        }
      }
    },
    groupedPropertyTypeFiltersRent() {
      this.payload.filtersList.other_sell = this.groupedPropertyTypeFiltersSell;
      this.payload.filtersList.other_rent = this.groupedPropertyTypeFiltersRent;
      if (this.editDataFilters.length) {
        const rentFilters = this.editDataFilters.filter(
          (el) => el.filter.deal_type === "rent"
        );
        for (let i in this.payload.filtersList.other_rent) {
          for (let j in this.payload.filtersList.other_rent[i].filters) {
            if (
              rentFilters.find(
                (el) =>
                  el.filter.name ===
                  this.payload.filtersList.other_rent[i].filters[j].filter
              )
            ) {
              this.payload.filtersList.other_rent[i].filters[j].model = true;
            }
          }
        }
      }
    },
    adminProperty() {
      if (Object.keys(this.adminProperty).length) {
        this.fillFilterList("adminProperty");
      }
    },
    "$i18n.locale"() {
      this.isRefresh = true;
      this.$nextTick(() => {
        this.isRefresh = false;
      });
    },
  },
  methods: {
    deleteAttachPhone(id) {
      this.payload.phone.attach_phones =
        this.payload.phone.attach_phones.filter((el) => el !== id);
    },
    onRegionChange() {
      if (this.payload.region) {
        this.isInvalidRegion = false;
        this.payload.markerCoords = [];
        this.payload.address = null;
        let currentPoly = this.localPolygons.find(
          (el) => el.id === this.payload.region
        );
        if (currentPoly.id === "norkmarash" || currentPoly.id === "zeytun") {
          currentPoly.polygonCoords[0].forEach((coordGroup) => {
            coordGroup.reverse();
          });
        }
        this.$nextTick(() => {
          if (
  this.$refs.yandMap &&
  this.$refs.yandMap.myMap &&
  typeof this.$refs.yandMap.myMap.setZoom === "function"
) {
  if (this.$refs.yandMap && this.$refs.yandMap.myMap && typeof this.$refs.yandMap.myMap.setZoom === "function") {
  const region = this.regions.find((el) => el.region === "yerevan");
  const zoomLevel = region && region.states.includes(this.payload.region) ? 13 : 10;
  
  this.$refs.yandMap.myMap.setZoom(zoomLevel);
}

if (this.$refs.yandMap && this.$refs.yandMap.myMap) {
  this.$refs.yandMap.myMap.setCenter([
    currentPoly.center[1],
    currentPoly.center[0],
  ]);
}

          }
        });
        this.polygonCoords = currentPoly.polygonCoords;
      } else this.polygonCoords = null;
    },
    changePropertyType(type) {
      this.item_type = type;
    },
    notAllowComma(key) {
      if (key.keyCode === 44) {
        key.preventDefault();
      }
    },
    typeSample(text0, text1, text2) {
      this.payload.translate_descriptions[0].description = text0;
      this.payload.translate_descriptions[1].description = text1;
      this.payload.translate_descriptions[2].description = text2;

      this.isOpenSampleDialog = false;
    },
    openSampleDialog(ind) {
      this.isOpenSampleDialog = true;
      this.langIndex = ind;
      this.samples[this.item_type].map((item) => (item.langIndex = ind));
    },
    closeUnsaveWarning() {},
    spaceValidation(e, index) {
      var regex = /[0-9]|\./;
      if (e.target.value.split("").every((el) => el === "0")) {
        e.target.value = "";
        this.payload.property_deal_types[index].price = e.target.value;
      }
      if (!regex.test(e.key) && e.code !== "Backspace") {
        e.target.value = e.target.value.replaceAll(e.key, "");
        this.payload.property_deal_types[index].price = e.target.value;
        e.preventDefault();
      } else {
        e.target.value = e.target.value.replace(/ /g, "");
        var number = e.target.value;
        this.payload.property_deal_types[index].price = number.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          " "
        );
      }
    },
    warningAddresShow() {
      this.isOpenAddressWarning = true;
    },
    warningAddresHide() {
      this.isOpenAddressWarning = false;
    },
    warningEmailShow() {
      this.isOpenEmailWarning = true;
    },
    warningPhoneShow() {
      this.isOpenPhoneWarning = true;
    },
    warningPhoneHide() {
      this.isOpenPhoneWarning = false;
    },
    warningEmailHide() {
      this.isOpenEmailWarning = false;
    },
    onNewNumberUpdate(obj) {
      this.isValidNewPhone = obj.isValid;
      this.payload.phone.add_phones.code = obj.countryCallingCode;
    },
    onSwitchAutoTranslate(source, target, target2) {
      if (this.autoTranslate) {
        this.debounceSearch2(source, target, target2);
      }
    },
    onCloseAddNumber(cond) {
      if (cond !== "confirm") {
        this.payload.phone.new_phones.number = null;
        this.payload.phone.new_phones.code = "+374";
        this.payload.phone.new_phones.viber = false;
        this.payload.phone.new_phones.whatsapp = false;
        this.payload.phone.new_phones.telegram = false;
        this.isConfirmed = false;
      } else {
        this.payload.phone.new_phones = { ...this.payload.phone.add_phones };
        this.payload.phone.add_phones = {};
        this.isConfirmed = true;
      }
      this.isOpenAddNewNumberDialog = false;
    },
    onTranslate(source, target, target2) {
      if (this.autoTranslate) {
        if (
          this.payload.translate_descriptions.find(
            (el) => el.language === source
          ).description
        ) {
          const text = this.payload.translate_descriptions
            .find((el) => el.language === source)
            .description.replace(/([.?!])\s*(?=[A-Z])/g, "$1|")
            .split("|");
          const url = `https://translation.googleapis.com/language/translate/v2?key=${process.env.VUE_APP_GOOGLE_API_KEY}&q=${text}&target=${target}&source=${source}`;
          axios.post(url).then((data) => {
            this.payload.translate_descriptions.find(
              (el) => el.language === target
            ).description = data.data.data.translations[0].translatedText;
          });
          const url2 = `https://translation.googleapis.com/language/translate/v2?key=${process.env.VUE_APP_GOOGLE_API_KEY}&q=${text}&target=${target2}&source=${source}`;
          axios.post(url2).then((data) => {
            this.payload.translate_descriptions.find(
              (el) => el.language === target2
            ).description = data.data.data.translations[0].translatedText;
          });
        } else {
          this.showTranslateWarning = true;
        }
      }
    },
    numeric(event) {
      if (event.key === "-" || event.key === "+") {
        event.preventDefault();
      }
    },
    decimals(event) {
      if (event.key === "." || event.key === "-" || event.key === "+") {
        event.preventDefault();
      }
    },
    getSortedFilters(deal_type) {
      return [...this.getPropertyTypeFilters].filter(
        (elem) => elem.deal_type === deal_type
      );
    },
    refetchFilters() {
      this.isLoadingFilters = true;
      this.$apollo
        .query({
          query: gql`
            query getPropertyTypeFilters($property_type: PropertyTypeEnum) {
              getPropertyTypeFilters(property_type: $property_type) {
                name
                filter_group {
                  name
                }
                deal_type
              }
            }
          `,
          variables: {
            property_type: this.payload.property_type,
          },
        })
        .then((data) => {
          this.getPropertyTypeFilters = data.data.getPropertyTypeFilters;
          this.isLoadingFilters = false;
        });
    },
    onAddPicture(e) {
      for (let i in e.target.files) {
        if (typeof e.target.files[i] === "object") {
          if (
            e.target.files[i].size / 1024 / 1024 <= 10 &&
            e.target.files.length <= 20
          ) {
            if (this.payload.filesArr.length < 20) {
              this.payload.filesArr.push(e.target.files[i]);
            } else {
              this.showImageCountSnackbar = true;
            }
          } else if (e.target.files[i].size / 1024 / 1024 > 10) {
            this.showImageSizeSnackbar = true;
          } else if (e.target.files.length > 20) {
            this.showImageCountSnackbar = true;
          }
        }
      }
    },
    fileToObjectUrl(file) {
      return (window.URL || window.webkitURL).createObjectURL(file);
    },
    deleteImage(index) {
      this.payload.filesArr.splice(index, 1);
    },
    deleteEditImage(id) {
      this.payload.property_images_delete_ids.push(id);
      this.editPropertyImages.splice(
        this.editPropertyImages.indexOf(
          this.editPropertyImages.find((el) => el.id === id)
        ),
        1
      );
    },
    fillFilterList(type) {
      const sellFilters = this[type].filters_values_not_null.filter(
        (el) => el.filter.deal_type === "sell"
      );
      const rentFilters = this[type].filters_values_not_null.filter(
        (el) => el.filter.deal_type === "rent"
      );
      const arr = [];
      if (sellFilters.length) {
        sellFilters.forEach((item) => {
          for (const key in this.payload.filtersList.other_sell) {
            this.payload.filtersList.other_sell[key].filters.find(
              (el) => el.filter === item.filter.name
            ) &&
              arr.push(
                this.payload.filtersList.other_sell[key].filters.find(
                  (el) => el.filter === item.filter.name
                )
              );
          }
        });
      }
      Object.values(this.payload.filtersList.other_sell).find((obj) => {
        for (let i in arr) {
          if (obj.filters.find((el) => el.filter === arr.filter)) {
            obj.filters.find((el) => el.filter === arr.filter).model = true;
          }
        }
      });
    },
    onPreview() {
      if (
        (this.$refs.createForm.validate() &&
          this.isSelectedOneOfPrices &&
          this.payload.region)
      ) {
        this.saveButtonLoading = true;
        this.isInvalid = false;
        const filters = [];
        for (let i in this.payload.filtersList.communal.filters) {
          if (this.payload.filtersList.communal.filters[i].model) {
            filters.push({
              filter: this.payload.filtersList.communal.filters[i].filter,
              value: "true",
            });
          }
        }
        if (this.payload.filtersList.other_rent) {
          for (let i in this.payload.filtersList.other_rent) {
            for (let j in this.payload.filtersList.other_rent[i].filters) {
              if (this.payload.filtersList.other_rent[i].filters[j].model) {
                filters.push({
                  filter:
                    this.payload.filtersList.other_rent[i].filters[j].filter,
                  value: "true",
                  deal_type: "rent",
                });
              }
            }
          }
        }
        if (this.payload.filtersList.other_sell) {
          for (let i in this.payload.filtersList.other_sell) {
            for (let j in this.payload.filtersList.other_sell[i].filters) {
              if (this.payload.filtersList.other_sell[i].filters[j].model) {
                filters.push({
                  filter:
                    this.payload.filtersList.other_sell[i].filters[j].filter,
                  value: "true",
                  deal_type: "sell",
                });
              }
            }
          }
        }
        const property_filter_values = [];
        this.payload.property_filter_values.forEach((item) => {
          if (item.value) {
            property_filter_values.push({
              filter: item.filter,
              value: +item.value,
            });
          }
        });
        const query = `mutation adminUpdateProperty($input: AdminUpdatePropertyInput) {
          adminUpdateProperty(input: $input) {
            id
          }
        }`;
        const variables = {
          input: {
            latitude: this.payload.markerCoords[0],
            longitude: this.payload.markerCoords[1],
            address: this.payload.address,
            postal_code: "+374",
            property_images: null,
            property_type: this.payload.property_type,
            property_filter_values: [
              ...filters,
              ...property_filter_values,
              {
                filter: "new_building",
                value: this.payload.new_building.toString(),
              },
            ],
            is_address_precise: !this.payload.is_address_precise,
            is_bids: this.payload.is_bids,
          },
        };
        variables.input.phone = {
          attach_phones: this.payload.phone.attach_phones,
        };
        if (
          this.payload.phone.new_phones &&
          this.payload.phone.new_phones.number
        ) {
          variables.input.phone.new_phones = [this.payload.phone.new_phones];
        }

        if (
          variables.input.phone.new_phones &&
          variables.input.phone.new_phones[0].__typename
        ) {
          delete variables.input.phone.new_phones[0].__typename;
        }
        if (this.payload.additional_email) {
          variables.input.email = this.payload.additional_email;
        }
        if (
          this.payload.property_deal_types.find(
            (elem) =>
              elem.price ||
              this.conditional.sale ||
              this.conditional.rent ||
              this.conditional.rentDay
          )
        ) {
          const filteredList = [
            ...this.payload.property_deal_types.filter(
              (elem) =>
                elem.price ||
                (elem.price === null && elem.currency_type_id === null)
            ),
          ];
          for (let i in filteredList) {
            if (typeof filteredList[i].price === "string") {
              filteredList[i].price = +filteredList[i].price.replaceAll(
                " ",
                ""
              );
            }
          }
          variables.input.region = this.payload.region;
          if (
            this.regions
              .find((el) => el.region === "yerevan")
              .states.find((el) => el === this.payload.region)
          ) {
            variables.input.region = `yerevan_${this.regions
              .find((el) => el.region === "yerevan")
              .states.find((el) => el === this.payload.region)}`;
          }

          variables.input.property_deal_types = filteredList;
          variables.input.property_deal_types.forEach((item) => {
            if (item.currency_type_id !== null) {
              item.currency_type_id = +item.currency_type_id;
            }
          });
        }
        if (
          this.payload.bulding_type_id !== this.$t("addproperty.building_type")
        ) {
          variables.input.bulding_type_id = +this.payload.bulding_type_id;
        }
        if (this.payload.land_area_type_id !== null) {
          variables.input.land_area_type_id = +this.payload.land_area_type_id;
        }
        if (
          this.payload.property_state !== this.$t("addproperty.property_cond")
        ) {
          variables.input.property_state = this.payload.property_state;
        }
        if (
          this.payload.translate_descriptions.find((elem) => elem.description)
        ) {
          variables.input.translate_descriptions =
            this.payload.translate_descriptions.filter(
              (elem) => elem.description
            );
        }
        const operations = {
          query,
          variables: {
            input: {
              ...variables.input,
              id: +this.$route.params.id,
              property_images_delete_ids:
                this.payload.property_images_delete_ids,
            },
          },
        };
        this.formData.append("operations", JSON.stringify(operations));
        const map = {
          property_images: ["variables.input.property_images"],
        };
        this.formData.append("map", JSON.stringify(map));
        for (let i in this.payload.filesArr) {
          if (typeof this.payload.filesArr[i] === "object") {
            this.formData.append("property_images[]", this.payload.filesArr[i]);
          }
        }
        console.log(operations.variables);
        this.editProperty()
      } else {
        if (!this.payload.region) {
          const el = document.getElementById("treeSelect");
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          this.isInvalidRegion = true;
        }
        if (this.isSelectedOneOfPrices) {
          this.isInvalid = true;
          this.$nextTick(() => {
            const el = document.querySelector(
              ".v-messages.error--text:first-of-type"
            );
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
          });
        } else {
          this.inValidPrice = true;
          this.$nextTick(() => {
            const el = this.$refs.property_deals_section;
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
          });
        }
      }
    },
    editProperty() {
      axios
        .post(process.env.VUE_APP_API_URL, this.formData, {
          headers: {
            Authorization: `Bearer ${this.apolloToken}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.saveButtonLoading = false;
          this.$router.push(`/admin/property/${$route.params.id}`);
        });
    },
    onDrag(e) {
      this.payload.markerCoords = e.get("target").geometry.getCoordinates();
      let currentPoly = this.localPolygons.find(
        (el) => el.id === this.payload.region
      );
      if (currentPoly.id === "norkmarash" || currentPoly.id === "zeytun") {
        currentPoly.polygonCoords[0].forEach((coordGroup) => {
          coordGroup.reverse();
        });
      }
      const objects = this.ymaps
        .geoQuery([
          {
            type: "Point",
            coordinates: this.payload.markerCoords,
          },
        ])
        .addToMap(this.$refs.yandMap.myMap);
      const polygon = new this.ymaps.Polygon(currentPoly.polygonCoords);
      this.$refs.yandMap.myMap.geoObjects.add(polygon);
      if (!objects.searchInside(polygon)._objects.length) {
        this.payload.markerCoords = [];
        this.payload.address = null;
        this.showOutsideSnackbar = true;
      } else {
        this.onGetAddress();
      }
      objects.removeFromMap(this.$refs.yandMap.myMap);
      this.$refs.yandMap.myMap.geoObjects.remove(polygon);
    },
    onClickMap(val, isMap) {
      if (isMap && this.polygonCoords) {
        this.showOutsideSnackbar = true;
        return;
      }
      if (!this.polygonCoords) {
        this.isInvalidRegion = true;
        return;
      }
      this.payload.markerCoords = val.get("coords");
      if (!this.isSelectingWrongAddress) {
        this.onGetAddress();
      }
    },
    onGetAddress() {
      const url = `https://geocode-maps.yandex.ru/1.x/?apikey=${process.env.VUE_APP_YANDEX_GEOCODE_API_KEY}&format=json&geocode=${this.payload.markerCoords[1]},${this.payload.markerCoords[0]}&lang=en-US&results=1`;
      axios.get(url).then((data) => {
        console.log(data)
        if (
          data.data.response.GeoObjectCollection.featureMember[0].GeoObject
            .metaDataProperty.GeocoderMetaData.Address.country_code === "AM" &&
          data.data.response.GeoObjectCollection.featureMember[0].GeoObject
            .metaDataProperty.GeocoderMetaData.kind !== "hydro"
        ) {
          this.payload.address =
            data.data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted.replace(
              `${data.data.response.GeoObjectCollection.featureMember[0].GeoObject.description
                .split(", ")
                .reverse()
                .join(", ")},`,
              ""
            ) +
            ` ${data.data.response.GeoObjectCollection.featureMember[0].GeoObject.description}`;
        } else {
          this.payload.address = null;
          this.payload.markerCoords = [];
        }
      });
    },
    lazySearch(isAutoFill) {
      const searchParamAddress = this.payload.address;
      const lang = localStorage.getItem("lang");
      let langUrl = "en_RU";
      if (lang === "hy") {
        langUrl = "hy-AM";
      } else if (lang === "ru") {
        langUrl = "ru-RU";
      } else if (lang === "en") {
        langUrl = "en_RU";
      }
      if (searchParamAddress) {
        const url = `https://search-maps.yandex.ru/v1/?apikey=${process.env.VUE_APP_YANDEX_HTTP_PLACES_API_KEY}&type=geo&text=${searchParamAddress}&lang=${langUrl}&rspn=1&bbox=43.5827458026,38.7412014837~46.5057198423,41.2481285671`;
        axios
          .get(url)
          .then((data) => {
            this.currentFoundItems = data.data.features.map((elem) => {
              return {
                name: `${elem.properties.name} ${
                  elem.properties.description || ""
                }`,
                pos: elem.geometry.coordinates,
                kind: elem.properties.GeocoderMetaData.kind,
              };
            });
            if (isAutoFill) {
              this.onSelectAddress(this.currentFoundItems[0]);
            }

            this.$nextTick(() => {
              if (this.$refs.combobox) {
  this.$refs.combobox.focus();
  this.$refs.combobox.activateMenu();
}

            });
          })
          .catch(() => {
            this.currentFoundItems = [];
          });
      }
    },
    onClickPriceInput(ref, target, model, nextModel, value) {
      if (!this.propertyDeals[model] && target !== "checkbox") {
        this.propertyDeals[model] = true;
      }
      if (nextModel) {
        this.propertyDeals[nextModel] = true;
      }
      if (
        this.propertyDeals[nextModel] &&
        target === "checkbox" &&
        !this.propertyDeals[model]
      ) {
        this.propertyDeals[nextModel] = false;
      }
      if (!this.propertyDeals[model] && value && target === "checkbox") {
        this.payload.property_deal_types.find(
          (elem) => elem.deal_type === value
        ).price = null;
      }
      if (
        model === "isInRent" &&
        !this.propertyDeals[model] &&
        !this.propertyDeals[nextModel]
      ) {
        this.payload.property_deal_types.find(
          (elem) => elem.deal_type === "monthly_rental_fee"
        ).price = null;
        this.propertyDeals.isInMonthlyRent = false;
      }
      if (
        model === "isInRentDay" &&
        !this.propertyDeals[model] &&
        !this.propertyDeals[nextModel]
      ) {
        this.propertyDeals.isInDailyRent = false;
        this.payload.property_deal_types.find(
          (elem) => elem.deal_type === "daily_rental_fee"
        ).price = null;
      }
      setTimeout(() => {
        this.$refs[ref].focus();
      }, 0);
    },
    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.lazySearch();
      }, 600);
    },
    debounceSearch2(source, target, target2) {
      clearTimeout(this.debounce2);
      this.debounce2 = setTimeout(() => {
        this.onTranslate(source, target, target2);
      }, 600);
    },
    onSelectAddress(e) {
      if (!this.isSelectingWrongAddress) {
        this.debounceSearch();
      }
      if (typeof e == "object") {
        if (e.pos) {
          let currentPoly = this.localPolygons.find(
            (el) => el.id === this.payload.region
          );
          if (currentPoly.id === "norkmarash" || currentPoly.id === "zeytun") {
            currentPoly.polygonCoords[0].forEach((coordGroup) => {
              coordGroup.reverse();
            });
          }
          const objects = this.ymaps
            .geoQuery([
              {
                type: "Point",
                coordinates: [e.pos[1], e.pos[0]],
              },
            ])
            .addToMap(this.$refs.yandMap.myMap);
          const polygon = new this.ymaps.Polygon(currentPoly.polygonCoords);
          if (this.$refs.yandMap && this.$refs.yandMap.myMap && this.$refs.yandMap.myMap.geoObjects) {
  this.$refs.yandMap.myMap.geoObjects.add(polygon);
}
          if (!objects.searchInside(polygon)._objects.length) {
            setTimeout(() => {
              this.payload.markerCoords = [];
              this.payload.address = null;
            }, 1000);
            this.showOutsideSnackbar = true;
          } else {
            if (e.kind !== "hydro") {
              this.payload.address = e.name;
              if (!this.isSelectingWrongAddress) {
                this.payload.markerCoords = [e.pos[1], e.pos[0]];
                this.coords = [e.pos[1], e.pos[0]];
              }
              if (this.payload.markerCoords.length) {
                let coords = [
                  +this.payload.markerCoords[0],
                  +this.payload.markerCoords[1],
                ];
                this.$refs.yandMap.myMap.zoomRange.get(coords).then((range) => {
                  this.zoom = range[1] - 3;
                  this.$refs.yandMap.myMap.setCenter(coords);
                });
              }
            } else {
              setTimeout(() => {
                this.payload.address = null;
                this.payload.markerCoords = [];
              }, 100);
            }
          }
          objects.removeFromMap(this.$refs.yandMap.myMap);
          this.$refs.yandMap.myMap.geoObjects.remove(polygon);
        }
      } else {
        this.payload.address = e;
      }
    },
    fillRequestBody(data) {
      this.payload.property_type = data.property_type.name;
      if (data.region && data.region.includes("yerevan_")) {
        this.payload.region = data.region.replaceAll("yerevan_", "");
      } else {
        this.payload.region = data.region;
      }
      this.item_type = data.property_type.name;
      if (data.property_deals.find((el) => el.deal_type.name === "sale")) {
        const sale = data.property_deals.find(
          (el) => el.deal_type.name === "sale"
        );
        if (sale.price !== null) {
          this.propertyDeals.isInSale = true;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "sale"
          ).currency_type_id = sale.currency_type.id;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "sale"
          ).price = sale.price;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "sale"
          ).deal_type = sale.deal_type.name;
        } else this.conditional.sale = true;
      }
      if (
        data.property_deals.find(
          (el) => el.deal_type.name === "monthly_rental_fee"
        )
      ) {
        const rental = data.property_deals.find(
          (el) => el.deal_type.name === "monthly_rental_fee"
        );
        if (rental.price !== null) {
          this.propertyDeals.isInRent = true;
          this.propertyDeals.isInMonthlyRent = true;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "monthly_rental_fee"
          ).currency_type_id = rental.currency_type.id;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "monthly_rental_fee"
          ).price = rental.price;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "monthly_rental_fee"
          ).deal_type = rental.deal_type.name;
        } else this.conditional.rent = true;
      }
      if (
        data.property_deals.find(
          (el) => el.deal_type.name === "daily_rental_fee"
        )
      ) {
        const daily = data.property_deals.find(
          (el) => el.deal_type.name === "daily_rental_fee"
        );
        if (daily.price !== null) {
          this.propertyDeals.isInRentDay = true;
          this.propertyDeals.isInDailyRent = true;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "daily_rental_fee"
          ).currency_type_id = daily.currency_type.id;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "daily_rental_fee"
          ).price = daily.price;
          this.payload.property_deal_types.find(
            (el) => el.deal_type === "daily_rental_fee"
          ).deal_type = daily.deal_type.name;
        } else this.conditional.rentDay = true;
      }
      this.payload.is_bids = data.is_bids;
      this.payload.is_address_precise = !data.is_address_precise;
      if (data.land_area_type) {
        this.payload.land_area_type_id = data.land_area_type.id;
      }
      if (data.property_attach_phones.length) {
        const propPhones = JSON.parse(
          JSON.stringify(
            data.property_attach_phones[data.property_attach_phones.length - 1]
          )
        );
        delete propPhones.id;
        this.payload.phone.add_phones = propPhones;
        this.payload.phone.new_phones = propPhones;
        this.payload.phone.attach_phones = data.property_attach_phones
          .slice(0, data.property_attach_phones.length - 1)
          .map((el) => {
            return +el.id;
          });
        this.onCloseAddNumber("confirm");
      }
      if (data.property_type.name === "mansion") {
        this.isSelectedLandArea = true;
      }
      const other_filters = data.filters_values_not_null.filter(
        (el) =>
          el.filter.filter_group.name === "undefined" &&
          el.filter !== "new_building"
      );
      const newBuildingFilter = data.filters_values_not_null.find(
  (el) => el.filter.name === "new_building"
);

this.payload.new_building = newBuildingFilter && newBuildingFilter.value === "true";

      for (let i in this.payload.property_filter_values) {
        if (
          other_filters.find(
            (el) =>
              el.filter.name === this.payload.property_filter_values[i].filter
          )
        ) {
          const found = other_filters.find(
            (el) =>
              el.filter.name === this.payload.property_filter_values[i].filter
          );
          this.payload.property_filter_values[i].value = found.value;
        }
      }
      this.payload.property_state = data.property_state;
      this.payload.bulding_type_id = data.bulding_type ? data.bulding_type.id : null;     
      if (data.translate_descriptions.find((el) => el.language.code === "en")) {
        this.payload.translate_descriptions.find(
          (el) => el.language === "en"
        ).description = data.translate_descriptions.find(
          (el) => el.language.code === "en"
        ).description;
      }
      if (data.translate_descriptions.find((el) => el.language.code === "hy")) {
        this.payload.translate_descriptions.find(
          (el) => el.language === "hy"
        ).description = data.translate_descriptions.find(
          (el) => el.language.code === "hy"
        ).description;
      }
      if (data.translate_descriptions.find((el) => el.language.code === "ru")) {
        this.payload.translate_descriptions.find(
          (el) => el.language === "ru"
        ).description = data.translate_descriptions.find(
          (el) => el.language.code === "ru"
        ).description;
      }
      if (data.email) {
        this.payload.additional_email = data.email;
      }
      if (data.property_images.length) {
        this.editPropertyImages = data.property_images;
      }
      this.editDataFilters = data.filters_values_not_null;
      this.$nextTick(() => {
        if (data.address) {
          console.log('setting address ...');
          this.payload.markerCoords = [data.latitude, data.longitude];
          this.coords = [data.latitude, data.longitude];
          this.onGetAddress()
        }
      });
    },
  },
  apollo: {
    currencyTypes: gql`
      query {
        currencyTypes {
          id
          name
        }
      }
    `,
    buldingTypes: gql`
      query {
        buldingTypes {
          id
          name
        }
      }
    `,
    landAreaTypes: gql`
      query {
        landAreaTypes {
          id
          name
        }
      }
    `,
    getPropertyTypeFilters: {
      query: gql`
        query getPropertyTypeFilters($property_type: PropertyTypeEnum) {
          getPropertyTypeFilters(property_type: $property_type) {
            name
            filter_group {
              name
            }
            deal_type
          }
        }
      `,
      variables() {
        return {
          property_type: this.item_type,
        };
      },
      fetchPolicy: "network-only",
    },
    adminProperty: {
      query: gql`
        query adminProperty($id: ID) {
          adminProperty(id: $id) {
            property_type {
              name
              id
            }
            region
            property_deals {
              deal_type {
                name
              }
              price
              currency_type {
                id
              }
            }
            property_attach_phones {
              id
              code
              number
              whatsapp
              viber
              telegram
            }
            is_bids
            latitude
            longitude
            address
            is_address_precise
            filters_values_not_null {
              filter {
                name
                deal_type
                filter_group {
                  name
                }
              }
              value
            }
            property_state
            bulding_type {
              id
            }
            land_area_type {
              id
            }
            property_images {
              id
              name {
                original
              }
            }
            translate_descriptions {
              description
              language {
                code
              }
            }
            email
            user {
              id
            is_admin
            full_name
            picture {
              min
              original
            }
            email
            phones {
              id
              number
              code
              viber
              whatsapp
              telegram
            }
            user_type {
              name
            }
            }
          }
        }
      `,
      variables() {
        return {
          id: +this.$route.params.id,
        };
      },
      skip() {
        return true;
      },
      fetchpolicy: "network-only",
    },
  },
  async mounted() {
    await loadYmap({ debug: true });
    this.ymaps = ymaps;
    
    this.$apollo.queries.adminProperty.skip = false;
    this.$apollo.queries.adminProperty.refetch().then(({ data }) => {
      this.fillRequestBody(data.adminProperty);
    });
  },
};
</script>

<style scoped>
.add-to-profile-switch >>> .v-label {
  margin: 0;
  color: black;
}
.add-to-profile-box {
  width: max-content;
}
.phone-input >>> .country-selector__list {
  height: 169px !important;
  top: 121% !important;
  z-index: 9999999999 !important;
}
.phone-input >>> .select-country-container .country-selector__label {
  display: none;
}
.phone-input >>> .country-selector__input {
  padding-top: 0 !important;
  padding-left: 34px !important;
  height: 47px;
  font-size: 15px;
  border-radius: 4px;
}
.phone-input >>> .country-selector__country-flag {
  top: 19px;
}
.phone-input >>> .select-country-container {
  width: 97px;
  min-width: 80px;
  max-width: 97px;
}
.phone-input >>> .input-tel__input {
  border-radius: 4px !important;
  height: 47px;
}
.phone-input >>> .country-selector__toggle img {
  width: 10px;
}
.phone-input >>> .country-selector__toggle {
  width: 21px;
}
.scroll::-webkit-scrollbar-track {
  background: none;
}
/deep/.tab-textarea textarea {
  margin-bottom: 80px;
}
.custom-disabled-placeholer-color >>> input::placeholder {
  color: grey !important;
  opacity: 0.2 !important;
}
.custom-placeholer-color >>> input::placeholder,
.custom-input >>> input::placeholder {
  color: grey !important;
  opacity: 0.7;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.sampleDialog {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px;
}
.new-phone {
  background-color: #edf9f5;
  height: 53px;
  padding: 0 0 3px 10px;
  border-radius: 5px;
}
.phone-number {
  font-size: 14px;
  color: #010302;
}
.left-side {
  width: 35%;
}
.right-side {
  justify-content: flex-start;
  padding-top: 40px;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.firstUpperCase span {
  text-transform: lowercase;
}
.firstUpperCase span::first-letter {
  text-transform: uppercase;
}
.main {
  width: 100%;
  padding-bottom: 50px;
  padding-top: 105px;
  min-height: 100vh;
  background-color: #fafafa;
  background-attachment: fixed;
  background-image: url("../../assets/images/add-background.svg");
  background-size: 110% 110%;
  background-repeat: no-repeat;
}
.circular-bar {
  width: 100%;
  height: 100vh;
  display: grid;
  align-items: center;
  place-content: center;
  align-content: center;
  place-items: center;
}
.main-container {
  width: 75%;
  margin: 0 auto;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  box-shadow: 0 0 15px 0 rgba(1, 3, 2, 0.2);
}
.card-section {
  width: 100%;
}
.delVMessage {
  margin: 0.3rem 0 -0.3rem 0;
}
.delVMessage >>> .v-label {
  font-size: 14px !important;
}
.delVMessage .v-messages {
  display: none !important;
}
.wrong-address-section {
  padding: 0 !important;
  margin-bottom: 20px;
  border: 1px solid #e91d46;
}
.wrong-address-section-padding {
  padding: 24px 42px 0;
}
.translation_icon {
  display: none;
}
.wrong-address-text-box {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 42px;
  font-size: 14px;
  color: white;
  background: #e91d46;
}
.wrong-address-cancel-button {
  text-transform: capitalize !important;
  font-size: 14px;
}
.first-section {
  padding: 50px 0;
}
.card-section-header {
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
  color: #010302;
  display: flex;
  justify-content: center;
}
.card-section-body_section {
  padding: 0 28px 0 28px;
  white-space: normal;
}
.disabled-property {
  opacity: 0.65;
  box-shadow: none !important;
  border: solid 1.5px #e6e6e6 !important;
}
.card-section-footer {
  display: flex;
  justify-content: space-between;
  margin: 0 25px 30px 5px;
}
.add-post-title {
  opacity: 0.36;
  font-size: 14px;
  text-align: left;
  color: #010302;
}
.divider {
  border: 1px solid #909090;
}
.d-flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.receive-quotes {
  margin-top: 0px;
  font-weight: 400;
  width: 20%;
}
.receive-quotes-help {
  max-width: 510px;
  height: 87px;
  margin-top: 12px;
  padding: 8px 18px 12px;
  opacity: 0.5;
  border-radius: 5px;
  border: solid 1px #ff805a;
}
.save-button,
.preview-button {
  border-radius: 10px;
}
.justify-space-between {
  justify-content: space-between;
}
.mb-10 {
  margin-bottom: 40px;
}
.property-type-box {
  width: 152px;
  height: 120px;
  transition: 0.2s;
  cursor: pointer;
  border-radius: 13px;
  border: 1.5px solid #e6e6e6;
}
.property-type-box {
  padding-top: 20px;
  display: grid !important;
  align-items: baseline;
}
.apartment:hover {
  box-shadow: 0 0 12px 0 rgba(41, 199, 252, 0.2) !important;
}
.mansion:hover {
  box-shadow: 0 0 12px 0 rgba(4, 167, 119, 0.2) !important;
}
.land_area:hover {
  box-shadow: 0 0 12px 0 rgba(255, 104, 35, 0.2) !important;
}
.commercial_area:hover {
  box-shadow: 0 0 12px 0 rgba(230, 58, 190, 0.2) !important;
}
.apartment {
  box-shadow: 2px 3px 9px 0 rgba(0, 0, 0, 0.15);
  border: solid 1.5px #5ad3fc;
}
.mansion {
  box-shadow: 2px 3px 9px 0 rgba(0, 0, 0, 0.15);
  border: solid 1.5px #68dfbb;
}
.land_area {
  box-shadow: 2px 3px 9px 0 rgba(0, 0, 0, 0.15);
  border: solid 1.5px #fdcebf;
}
.commercial_area {
  box-shadow: 2px 3px 9px 0 rgba(0, 0, 0, 0.15);
  border: solid 1.5px #f5b3e6;
}
.gap-8 {
  gap: 32px;
}
.label-underline >>> label {
  text-decoration: underline;
  white-space: nowrap;
}
.add_phone .checkmark >>> label {
  left: 0px !important;
}

.checkmark >>> label {
  left: 5px !important;
  color: black;
  top: 5px;
}
.warning-text {
  display: flex;
  justify-content: space-between;
  width: 1425px;
  height: 42px;
  padding: 12px 25px 11px 40px;
  margin-bottom: 35px;
  border: solid 1px #e91d46;
  background-color: #e91d46;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  color: var(--white);
}
/* Chrome, Safari, Edge, Opera */
.custom-input >>> input::-webkit-outer-spin-button,
.custom-input >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.custom-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.custom-input >>> .v-input__slot {
  min-height: 48px !important;
}
.custom-currency-select >>> .v-input__slot {
  min-height: 48px !important;
}
.custom-currency-select >>> .v-input__control {
  height: 48px !important;
}
.custom-currency-select >>> .v-input__append-inner {
  margin-top: 12px !important;
}
.custom-currency-select {
  max-width: 93px;
  height: 48px !important;
  min-height: 48px;
}
.price-input {
  display: flex;
  gap: 16px;
  max-width: 480px;
  height: 48px;
}
.rent-section-month {
  margin: 0;
}
.rent-section-day {
  margin-top: 0;
}
.conditional-checkbox {
  display: flex;
  justify-content: flex-end;
  max-width: 475px;
}
.rent-conditional-checkbox {
  display: flex;
  justify-content: flex-end;
  max-width: 505px;
  padding-right: 4px;
}
.img-gps {
  width: 11px;
  height: 16px;
  object-fit: contain;
}
.map-mention {
  margin: 0 0 0 8px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #010302;
}
.translate-switch >>> .v-label {
  margin: 0;
}
.translate-switch {
  margin: 0;
  padding-right: 8px;
  margin-left: 12px;
}
#wrong_address {
  color: #004af1;
  font-size: 16px;
  font-weight: normal;
  text-decoration: underline;
}
.switch {
  margin-left: 12px;
  padding-bottom: 8px;
}
.switch >>> .v-label {
  margin: 0;
  color: black;
}
.select {
  border: 1px solid black;
  border-radius: 5px;
  width: 93px;
  height: 48px;
  margin: 0;
  color: black;
  padding: 0 20px;
}
.bold {
  font-size: 14px !important;
  font-weight: bold;
}
.bold {
  font-size: 16px !important;
  font-weight: bold;
}
.w-60 {
  width: 60%;
}
.row {
  display: flex;
  margin-bottom: 15px;
}
.col {
  max-width: 305px;
  height: 92px;
}
.col label {
  white-space: nowrap;
}
.col-ceiling {
  max-width: 98%;
}
.col-ceiling >>> v-select {
  width: 90px;
}
.select-big {
  width: 606px;
}
.select-big >>> .v-label {
  color: black;
  top: 15px;
}
.select-big >>> .v-input__slot {
  min-height: 48px !important;
}
.select-big >>> .v-input__append-inner {
  margin-top: 12px !important;
  padding: 1px;
}
.select-big .v-select__selections .v-select__selection--comma {
  padding: 1px !important;
}
::v-deep .v-select__selection--comma {
  padding: 1px;
}
.gray-bg {
  background: #f5f5f5;
}
.filter-title {
  font-weight: 600;
  font-size: 18px;
}
.expansion-panel >>> .v-expansion-panel {
  background: transparent;
}
.expansion-panel >>> .v-expansion-panel::before {
  box-shadow: none !important;
}
.tab-title {
  text-transform: capitalize;
  letter-spacing: 0;
}
.tab-textarea {
  margin: 20px 16px 0;
  border-radius: 5px;
  padding: 5px 10px;
  border: none !important;
}
.image-box,
.image-box-edit {
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  gap: 0 8px;
}
.image-box-edit {
  display: flex;
}
.image-box-edit::-webkit-scrollbar {
  height: 4px;
}

.image-box-edit::-webkit-scrollbar-track {
  background: none;
}

.image-box-edit::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

.image-box::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.image-box::-webkit-scrollbar {
  height: 4px;
}

.image-box::-webkit-scrollbar-track {
  background: none;
}

.image-box::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

.image-box::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.action {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  font-size: 16px;
  color: black !important;
}
.img-text {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #010302;
}
.ymap-container {
  top: 0;
}
.ymaps-2-1-79-controls__toolbar_left {
  display: none !important;
}
.ymap-input {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px solid silver;
  height: 48px;
  padding-left: 8px;
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.combobox {
  width: 60%;
}
.combobox-treeselect {
  width: 371px;
  height: 48px;
  box-shadow: none !important;
}
.combobox-treeselect >>> .vue-treeselect__control {
  height: 48px;
  border-color: darkgray;
  box-shadow: none !important;
}
.combobox-treeselect >>> .vue-treeselect__control:hover {
  border-color: black !important;
}
.combobox-treeselect >>> .vue-treeselect__control-arrow {
  fill: black;
}
.combobox-treeselect >>> .vue-treeselect__placeholder {
  display: grid;
  align-items: center;
}
.combobox-treeselect >>> .vue-treeselect__single-value {
  display: grid;
  align-items: center;
}
.error-field >>> .vue-treeselect__control {
  border-color: red !important;
}
.combobox >>> .v-input__slot {
  min-height: 48px !important;
}
.checkmark >>> .v-label {
  white-space: nowrap;
}
.combobox >>> i {
  display: none !important;
}

.warning-box {
  position: absolute;
  top: 100%;
  left: 7px;
  transform: translate(-50% -50%);
  width: 200px;
  padding: 10px 15px;
  border-radius: 5px;
  background: #fff;
  z-index: 1;
  box-shadow: -1px -1px 24px 1px rgba(34, 60, 80, 0.2);
  font-size: 14px;
  color: black;
}

.unsaved-text {
  font-weight: 600;
  font-size: 16px;
}
.list-phones {
  gap: 0 40px;
}
.add-new-phone-button {
  box-shadow: 0 0 6px 0 rgba(1, 3, 2, 0.15);
  border: none !important;
  text-transform: capitalize !important;
  letter-spacing: 0;
  margin-left: 40px;
}
.add-new-phone-button >>> .v-btn__content {
  gap: 0 34px;
}
.add-new-number-button {
  color: white !important;
  letter-spacing: 0;
  text-transform: capitalize;
}
.cancel-add-new-number-button {
  border-color: #04a777 !important;
  color: #04a777 !important;
  letter-spacing: 0;
  text-transform: capitalize;
}
.attached-phone {
  background: #edf9f5;
  border-radius: 5px;
  padding: 4px 4px;
}
@media only screen and (max-width: 1823px) {
  .image-box {
    overflow-x: scroll;
  }
}
@media only screen and (max-width: 1440px) {
  .property-deals-section {
    flex-direction: column;
  }
  .price-input {
    max-width: 515px !important;
  }
  .rent-input {
    width: 515px !important;
  }
  .rent-conditional-checkbox {
    margin-bottom: 0;
  }
  .rent-section-day {
    margin-top: 0;
  }
  .rent-conditional-checkbox {
    justify-content: flex-start;
  }
  .conditional-checkbox {
    justify-content: flex-start !important;
  }
  @media only screen and (max-width: 1283px) {
    .right-side {
      padding-right: 115px !important;
    }
    .template-columns {
      grid-template-columns: repeat(3, 1fr) !important;
    }
    .input {
      min-width: 0;
    }
    .communal-span {
      max-width: 93px !important;
    }
  }
  @media only screen and (max-width: 1110px) {
    .right-side {
      padding-right: 77px !important;
    }
  }
  .checkmark >>> .v-label span {
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 200px;
  }
  .more-button {
    background-image: linear-gradient(
      180.55deg,
      rgba(1, 3, 2, 0.4) 100%,
      rgba(229, 229, 229, 0) 7.39%,
      rgba(230, 230, 230, 0) 49.69%
    );
    cursor: pointer;
    background-size: 100% 100%;
    display: grid;
    place-items: center;
    align-items: center;
    font-size: 32px;
   
    color: white;
    text-shadow: 2px 2px 4px #000000;
    font-weight: 600;
  }

  @media only screen and (max-width: 990px) {
    .add-property-section {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      width: max-content;
      margin: 0 auto;
    }
    .receive-quotes {
      margin-top: 0;
    }
    .rent-conditional-checkbox {
      margin-bottom: 30px;
    }
    .property-deals-section_box {
      width: 100% !important;
    }
    .additional-email-box {
      width: 100% !important;
      flex-direction: column;
    }
    .communal-span {
      max-width: 300px !important;
    }
    .template-columns {
      grid-template-columns: repeat(2, 1fr) !important;
    }
    .select-big {
      width: 100%;
    }
    .input {
      width: 100%;
    }
    label[for="mRent"],
    label[for="dRent"] {
      margin-bottom: 0 !important;
    }
    .col input {
      width: 100%;
      max-width: 100%;
    }
    .main-container {
      width: 79%;
    }
  }
  .right-side {
    padding-top: 15px;
    padding-right: 0 !important;
  }
  .left-side,
  .right-side,
  #mRent,
  #dRent,
  #sale {
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
  }
}
@media only screen and (max-width: 880px) {
  .footer-buttons {
    margin-right: 0 !important;
  }
  .action {
    font-size: 15px;
  }
  .bottom-buttons >>> .v-btn {
    padding: 0 14px;
  }
  .bottom-buttons {
    gap: inherit !important;
  }
  .main-container {
    width: 82%;
  }
}
@media only screen and (max-width: 800px) {
  .bottom-buttons >>> .v-btn {
    padding: 0 10px;
  }
}
@media only screen and (max-width: 780px) {
  .main-container {
    width: 90%;
  }
  .contacts-info {
    margin-bottom: 20px;
  }
  label {
    font-size: 14px;
  }
  .phone-info-section {
    flex-direction: column;
  }
  .bottom-buttons {
    width: 100%;
    align-items: center;
    /* justify-content: center !important; */
  }
  .phone-col {
    margin-bottom: 15px;
  }
  .footer-buttons {
    /* flex-direction: column; */
    /* padding: 0 15px; */
    font-size: 30px !important;
  }
  .template-columns {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .checkmark >>> .v-label span {
    font-size: 12px;
    max-width: 300px;
  }
  .description-lang {
    display: none;
  }
  .translate-switch-button >>> .tab-title {
    min-width: inherit !important;
  }
  .bottom-buttons {
    width: 98%;
  }
  .bold2 {
    text-align: center;
  }
}

@media only screen and (max-width: 725px) {
  .col {
    width: 100%;
    max-width: 100%;
  }
  .row {
    flex-direction: column;
  }
  label {
    display: block;
  }
}
@media only screen and (max-width: 650px) {
  .bottom-buttons {
    display: flex;
    flex-direction: column-reverse;
    gap: 15px !important;
  }
  .footer-buttons {
    display: flex;
    flex-direction: column-reverse;
    gap: 3px !important;
  }
}
@media only screen and (max-width: 585px) {
  .translate-switch >>> .v-label {
    font-size: 14px !important;
  }
  .main-container {
    width: 90%;
  }

  .receive-quotes-help {
    height: auto;
  }
  .card-section-body_section {
    padding: 0 15px;
    white-space: normal;
  }
  .select-addres {
    padding: 0px 18px 15px 17px !important;
  }
}
@media only screen and (max-width: 480px) {
  .price-input,
  .rent-input {
    background-color: #fafafa;
    border-top: solid 0.5px #e6e6e6;
    height: 70px !important;
    padding: 20px 15px 0;
  }
  .rent-input {
    margin-top: 0;
  }
  .conditional-checkbox,
  .rent-conditional-checkbox {
    background-color: #fafafa;
    border-bottom: solid 0.5px #e6e6e6;
    margin-top: 5px;
  }
  .checkmark {
    padding: 0 15px;
    margin-top: 16px !important;
  }
  .receive-quotes-help,
  .add-post-title {
    margin: 0 15px !important;
  }
  .receive-quotes-help {
    margin: 15px 0 0;
    padding: 13px 12px 12px 13px;
    opacity: 0.5;
    border-radius: 5px;
    border: solid 1px #ff805a;
    font-size: 11px;
  }
  .v-select__selection--comma {
    min-width: 25px !important;
  }
  .rent-conditional-checkbox {
    margin-bottom: 0;
  }
  .card-section-body-bg,
  .right-side {
    padding: 0 !important;
  }
  .sampleDialog {
    grid-template-columns: 1fr;
  }
  .numbers_box {
    flex-direction: column;
    align-items: baseline;
  }
  .contact-title {
    text-align: center;
  }
  .bottom-buttons {
    width: 93%;
  }
  .numbers_box >>> .phone-col {
    flex-direction: column;
    margin-bottom: 5px;
    min-width: 160px;
  }
  .add-new-phone-button {
    margin-left: 0;
  }
  .numbers_box > div:nth-child(2) {
    margin-left: 0 !important;
  }
  .map-mention {
    font-size: 14px;
  }
  #wrong_address {
    font-size: 14px;
  }
  .card-section {
    width: 100%;
  }

  .card-section-footer {
    margin-right: 10px !important;
    margin-left: 12px;
  }
  .add-property-section {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    width: max-content;
    padding: 0;
    margin: 0 auto;
  }
  /* .property-type-box {
    width: 100px;
    font-size: 10px;
  } */
  /* .property-type-box div {
    font-size: 10px;
  } */
  /* .property-type-name {
    font-size: 16px;
    color: #010302;
  } */
  .preview-button {
    width: 100%;
    margin-right: 0;
  }
  .preview-button >>> span {
    font-size: 15px;
  }
  input,
  select,
  textarea {
    font-size: 14px;
  }
  .custom-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
  .main-container {
    width: 95%;
  }
  .translate-switch-button {
    display: flex !important;
    flex-direction: column-reverse;
  }
  .translate-switch-button >>> .tab-title {
    min-width: 33% !important;
  }
  .property-deals-section_box {
    width: 100% !important;
  }
  .ymap-container {
    height: 240px !important;
  }
  .card-section-header {
    font-size: 22px;
  }
  .contacts-info > div {
    flex-direction: column;
    text-align: center;
    margin-bottom: 5px;
    min-width: 160px;
  }
  .custom-input >>> .v-input__slot {
    min-height: 42px !important;
  }
  .custom-currency-select >>> .v-input__slot {
    min-height: 42px !important;
    margin-bottom: 2px !important;
  }
  .custom-currency-select >>> .v-input__control {
    height: 42px !important;
    width: 89px !important;
    min-width: 93px;
  }
  .custom-currency-select >>> .v-input__append-inner {
    margin-top: 8px !important;
  }
  .custom-currency-select {
    max-width: 89px;
    height: 42px !important;
    min-height: 42px;
  }
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    margin-bottom: 2px !important;
  }
  .price-input {
    height: 42px;
  }
  .price-input >>> .v-input__slot {
    margin-bottom: 2px;
  }
}
@media only screen and (max-width: 425px) {
  .upload-file > img {
    width: 150px;
    object-fit: scale-down;
    height: 150px;
  }
  .land_area .property-type-name {
    padding: 0px 14px;
    font-size: 12px !important;
  }
  .warning-box {
    left: -85px;
  }
  .upload-file {
    margin-bottom: 0;
  }
  .property-type-box {
    width: 140px;
    height: 90px;
    font-size: 14px;
  }
  .property_name img {
    width: 32px;
    height: 32px;
  }
  .property_name {
    margin-bottom: 10px !important;
  }
  .commercial_area >>> .property-type-name {
    font-size: 12px !important;
  }
  .address-search-fields {
    flex-direction: column;
  }
  .combobox {
    width: 100%;
    margin-left: 0 !important;
  }
  .combobox-treeselect {
    width: 100%;
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 415px) {
  .map-mention {
    font-size: 13px;
  }
  #wrong_address {
    font-size: 13px;
  }
  .card-section-header {
    font-size: 20px;
  }
  .ymap-container {
    height: 190px !important;
  }
  .add-new-number-button {
    width: 125px !important;
    margin: 0 !important;
  }
  .cancel-add-new-number-button {
    margin: 0 !important;
    width: 125px !important;
  }
  .add_phone {
    padding: 10px 10px 10px 10px;
  }
}
@media only screen and (max-width: 380px) {
  .main-container {
    width: 100%;
  }
}
@media only screen and (max-width: 360px) {
  .main {
    padding-top: 55px;
  }
  .main-container {
    width: 100%;
  }
  .card-section-header {
    font-size: 16px;
    padding: 20px 0 0 0;
  }
  .select-addres {
    display: inherit !important;
  }
  .first_divider {
    display: none;
  }
  .numbers_box {
    display: block !important;
    text-align: center;
  }
  .list-phones {
    display: block !important;
  }
  .phone-number-box {
    display: block !important;
    align-items: center !important;
    gap: 10px !important;
    text-align: center !important;
  }
  .new-phone {
    display: flex !important;
  }
  .Logo_checkmark {
    margin-bottom: 0 !important;
  }
  .translation_icon {
    display: block !important;
    position: relative;
    top: 303px;
    z-index: 1;
    left: 220px;
    height: 20px;
  }
  .inputAreaBtn {
    bottom: 53px !important;
    font-size: 11px !important;
    left: 20px !important;
  }
  .translation_button {
    overflow: visible !important;
  }
  label[for="mRent"] {
    margin-left: 0 !important;
    margin-bottom: 0;
  }
  .card-section-body {
    padding: 20px 5px 0;
  }
  .property-type-name {
    font-size: 14px !important;
  }
  .left-side >>> .v-text-field__details {
    padding-top: 1px;
  }
  .right-side >>> .v-text-field__details {
    padding-top: 1px;
  }
  .right-side {
    width: 100%;
    padding-bottom: 20px;
  }
  .right-side >>> .v-input__slot {
    margin-bottom: 0;
  }
  .right-side >>> .checkmark {
    margin-top: 0;
  }
  .property-deals-section_box {
    width: unset !important;
  }
  .property-deals-section_box >>> .checkmark {
    margin-bottom: 0 !important;
    margin-top: 7px;
  }
  .property_name {
    margin-bottom: 7px !important;
  }
  .upload-file > img {
    width: 140px;
  }
  .first-section >>> .card-section-body_section {
    padding: 0 8px;
  }
  .rent-input {
    margin-top: 0 !important;
  }
}
@media only screen and (max-width: 320px) {
  .card-section-header {
    font-size: 18px;
  }
  .phone-input >>> .input-tel__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
  }
  .card-section-body_section {
    padding: 0 11px 0 11px;
    white-space: normal;
  }
  .add-post-title {
    text-align: center;
  }
  .expansion-panel >>> .v-expansion-panel-header {
    font-size: 15px !important;
  }
  .subtitle {
    font-size: 14px !important;
  }
  .property-type-box {
    width: 136px;
  }
  .checkmark >>> .v-label span {
    font-size: 12px !important;
  }
  .img-card--footer {
    flex-direction: column !important;
  }
  .img-card--footer .v-btn {
    width: 100% !important;
    margin-left: 0 !important ;
  }
  .image-box--outer {
    padding: 0 !important;
  }
  .image-box--outer .v-image {
    margin: 0 auto !important;
  }
}
.first-rent-inp >>> .v-input__slot {
  margin-bottom: 3px;
}
</style>
